import "./AmTrade.scss";
import AllDocsNote from "../../../components/allDocsNote/AllDocsNote.jsx";
import AllFiles from "../../../components/allFiles/AllFiles.jsx";
import ConfirmDialog from "../../../components/confirmDialog/confirmDialog.jsx";
import CircularButton, {
    CustomButtonSmall,
    CustomLoadingButton,
} from "../../../components/ui/CustomButton.jsx";
import {
    DialogActions,
    Dialog,
    DialogTitle,
    DialogContent,
    Tooltip,
    Table,
    TableContainer,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Paper,
    TablePagination
} from "@mui/material";
import { customSelectStyles_dark, customSelectStyles_light } from "../../../components/ui/CustomSelect.jsx";
import { showToast } from "../../../toastService.js";
import DOMPurify from 'dompurify';
import { calculateAccruedInterest, calculateFDDetails, calculateTBillFromDiscountRate, calculateTBillFromTenor, calculateTBillReturns, fetchClientsBySearch, formatAmountsToDecimals, formatNumber, formatStringToNumberV2, numberToWordsWithDecimal } from "../../../utils/genericFunctions.js";
import newRequest from "../../../utils/newRequest.js";
import { motion } from "framer-motion";
import moment from "moment";
import numeral from "numeral";
import { useEffect, useRef, useState } from "react";
import Confetti from "react-confetti";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import AsyncSelect from "react-select/async";
import { useTranslation } from "react-i18next";
import { GridLoader, ScaleLoader } from "react-spinners";
import { CiImageOn } from "react-icons/ci";
import { MdAdd, MdClose, MdDelete, MdEditDocument, MdEmail, MdOutlineNumbers, MdPhone, MdRefresh, MdSave, MdSms, MdDragIndicator, MdOutlineMenuOpen, MdOutlineReceiptLong } from "react-icons/md";
import Badge from '@mui/material/Badge';
import ValidationMessages from "../../../components/validationMessages/ValidationMessages.jsx";
import EmailComponent from "../../../components/emailComponent/EmailComponent.jsx";
import OnScreenReports from "../../../components/onScreenReports/OnScreenReports.jsx";
import { IoChatbubbles, IoDocumentTextSharp } from "react-icons/io5";
import { HiOutlineLink } from "react-icons/hi2";
import { RiAttachment2, RiSendPlaneFill } from "react-icons/ri";
import HRHandbook from "../../../components/test/HRHandbook.jsx";
import FileUploadComponent from "../../../components/fileUploadComponent/FileUploadComponent.jsx";
import ExpandableComponent from "../../../components/expandableComponent/ExpandableComponent.jsx";
import { TagIcon } from "lucide-react";
import Taccount from "../../../components/taccount/Taccount.jsx";
import WorkedOnBy from "../../../components/workedOnBy/WorkedOnBy.jsx";
import Correspondence from "../../../components/correspondence/Correspondence.jsx";
import AmSchedule from "../amSchedule/AmSchedule.jsx";

const AmTrade = () => {
    const { t } = useTranslation();
    const [isProcessing, setIsProcessing] = useState(false);
    const { currentUser } = useSelector((state) => state.user);
    const { currentTheme } = useSelector((state) => state.theme);
    const [isLoading, setIsLoading] = useState(false);
    const [isNotifyDialogOpen, setIsNotifyDialogOpen] = useState(false);
    const [notifyDialogTitle, setNotifyDialogTitle] = useState("Confirm");
    const [notifyDialogText, setNotifyDialogText] = useState("Text");
    const navigate = useNavigate();
    const [isConfettiActive, setIsConfettiActive] = useState(false);
    const [refreshKey, setRefreshKey] = useState(0);
    const [tradeData, setTradeData] = useState(null);
    const [funds, setFunds] = useState([]);
    const [selectedFund, setSelectedFund] = useState(null);
    const [figuresToShow, setFiguresToShow] = useState("org");
    const { docid } = useParams();
    const [tradeDocId, setTradeDocId] = useState(null);
    const brokerRef = useRef(null);
    const tradeTypeRef = useRef(null);

    const [emailDialogOpen, setEmailDialogOpen] = useState(false);
    const [emailData, setEmailData] = useState(null);
    const [selectedBroker, setSelectedBroker] = useState(null);
    const [reportsDialogOpen, setReportsDialogOpen] = useState(false);
    const [documentEnabled, setDocumentEnabled] = useState("Y");
    const [nextAction, setNextAction] = useState("Complete");
    const [validationMsgDialog, setValidationMsgDialog] = useState(false);
    const [validationMessagesResult, setValidationMessagesResult] = useState({});
    const [objectToAction, setObjectToAction] = useState({
        object_id: "",
        action_text: "",
        new_doc_status: "",
    });
    const [invokedAction, setInvokedAction] = useState("");
    const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
    const [confirmDialogAction, setConfirmDialogAction] = useState("None");
    const [traceData, setTraceData] = useState([]);
    const [attachmentsData, setAttachmentsData] = useState([]);
    const [tradeTypes, setTradeTypes] = useState([]);
    const [settlementStatuses, setSettlementStatuses] = useState([]);
    const [conventions, setConventions] = useState([]);
    const [tradeFees, setTradeFees] = useState([]);
    const [selectedFee, setSelectedFee] = useState(null);
    const [totalFeesFc, setTotalFeesFc] = useState(0);
    const [totalFeesLc, setTotalFeesLc] = useState(0);
    const [definedFees, setDefinedFees] = useState([]);
    const [selectedDefinedFee, setSelectedDefinedFee] = useState(null);
    const [rateTypes, setRateTypes] = useState([]);
    const [marketTypes, setMarketTypes] = useState([]);
    const [couponFrequencies, setCouponFrequencies] = useState([]);
    const [branches, setBranches] = useState([]);
    const [currencies, setCurrencies] = useState([]);
    const [priorityLevels, setPriorityLevels] = useState([]);
    const [securities, setSecurities] = useState([]);
    const [selectedSecurity, setSelectedSecurity] = useState(null);
    const [settleTradeDialogOpen, setSettleTradeDialogOpen] = useState(false);
    const [additionalActionsMenu, setAdditionalActionsMenu] = useState(false);
    const [profileLimitValues, setProfileLimitValues] = useState([]);
    const actionsMenuRef = useRef(null);

    // top menu 
    const handleTabClick = (index) => {
        setActiveTab(index);
    };
    const [activeTab, setActiveTab] = useState(0);

    function getMenuTitle(menuKey) {
        switch (menuKey) {
            case 'details':
                return t('details');
            case 'attachments':
                return t('attachments');
            case 'matching':
                return t('matching');
            case 'correspondence':
                return t('correspondence');
            case 'comments':
                return t('comments');
            default:
                return '';
        }
    }

    const topMenus = [
        {
            menu_key: "details",
            menu_title: getMenuTitle("details"),
            menu_icon: <MdEditDocument />,
            menu_count: 0,
        },
        {
            menu_key: "attachments",
            menu_title: getMenuTitle("attachments"),
            menu_icon: <RiAttachment2 />,
            menu_count: attachmentsData.length,
        },
        {
            menu_key: "matching",
            menu_title: "Matching",
            menu_icon: <HiOutlineLink />,
            menu_count: 0,
        },
        {
            menu_key: "correspondence",
            menu_title: getMenuTitle("correspondence"),
            menu_icon: <MdSms />,
            menu_count: 0,
        },
        {
            menu_key: "comments",
            menu_title: getMenuTitle("comments"),
            menu_icon: <IoChatbubbles />,
            menu_count: 0,
        },
    ];

    const handleTradeFeeChange = (e, id, field) => {
        try {
            const newSmiData = [...tradeFees];
            const index = newSmiData.findIndex(smi => smi._id === id);
            if (index !== -1) {
                if (e && e.target) {
                    // Regular input
                    newSmiData[index][field] = e.target.value;
                } else if (e && typeof e === "object") {
                    // react-select returns the whole selected option object
                    newSmiData[index][field] = e.value;
                }
                setTradeFees(newSmiData);
            }
        } catch (error) {
            console.log(error);
        }
    };


    const refreshTbillNumbers = () => {
        try {

            if (!tradeData?.face_value_fc && !tradeData?.tbill_start_date && !tradeData?.tbill_tenor && !tradeData?.tbill_discount_rate) return;

            const faceValue = parseFloat(formatStringToNumberV2(tradeData?.face_value_fc));
            const fromDate = moment(tradeData?.tbill_start_date).format("YYYY-MM-DD");
            const tenorDays = parseFloat(formatStringToNumberV2(tradeData?.tbill_tenor));
            const discountRate = parseFloat(formatStringToNumberV2(tradeData?.tbill_discount_rate));


            // console.log(`faceValue ... ${faceValue}`);
            // console.log(`fromDate ... ${fromDate}`);
            // console.log(`tenorDays ... ${tenorDays}`);
            // console.log(`discountRate ... ${discountRate}`);

            const calculatedValues = calculateTBillFromDiscountRate({ faceValue, fromDate, tenorDays, discountRate });
            console.log(`calculatedValues ${JSON.stringify(calculatedValues, null, 2)}`);
            handleSetTradeData("tbill_maturity_date", calculatedValues?.maturityDate);
            handleSetTradeData("hd_fc_amount", formatAmountsToDecimals(calculatedValues?.investedAmount || 0, 2));
            const lcAmount_0 = parseFloat((calculatedValues?.investedAmount * (tradeData?.hd_cur_rate || 1)).toFixed(4));
            handleSetTradeData("hd_lc_amount", formatAmountsToDecimals(lcAmount_0 || 0, 2));

            handleSetTradeData("tbill_price_fc", formatAmountsToDecimals(calculatedValues?.purchasePrice || 0, 2));
            const lcAmount_1 = parseFloat((calculatedValues?.purchasePrice * (tradeData?.hd_cur_rate || 1)).toFixed(4));
            handleSetTradeData("tbill_price_lc", formatAmountsToDecimals(lcAmount_1 || 0, 2));

            handleSetTradeData("tbill_discount_fc", formatAmountsToDecimals(calculatedValues?.discountAmount || 0, 2));
            const lcAmount_2 = parseFloat((calculatedValues?.discountAmount * (tradeData?.hd_cur_rate || 1)).toFixed(4));
            handleSetTradeData("tbill_discount_lc", formatAmountsToDecimals(lcAmount_2 || 0, 2));

            handleSetTradeData("tbill_yeild_maturity", formatAmountsToDecimals(calculatedValues?.yieldToMaturity || 0, 4));
            handleSetTradeData("tbill_quantity", formatAmountsToDecimals(calculatedValues?.quantity || 0, 4));
        } catch (error) {
            console.log(error);
        }
    };


    const refreshFixedDeposit = () => {
        try {

            if (!tradeData?.fd_tenor_in_days && !tradeData?.fd_start_date && !tradeData?.fd_maturity_date) return;
            const principalFc = parseFloat(formatStringToNumberV2(tradeData?.fd_principal_fc));
            const interestType = tradeData?.fd_interest_type || "Simple";
            const fromDate = moment(tradeData?.fd_start_date).format("YYYY-MM-DD");
            const tenorDays = parseFloat(formatStringToNumberV2(tradeData?.fd_tenor_in_days));
            const interestRate = parseFloat(formatStringToNumberV2(tradeData?.fd_interest_rate));
            const compoundFrequency = 1;

            const calculatedValues = calculateFDDetails({ principal: principalFc, interestType, annualRate: interestRate, startDate: fromDate, tenorInDays: tenorDays, compoundFrequency });
            console.log(`calculatedValues ${JSON.stringify(calculatedValues, null, 2)}`);
            handleSetTradeData("fd_maturity_date", calculatedValues?.maturityDate);
            handleSetTradeData("fd_interest_fc", formatAmountsToDecimals(calculatedValues?.interestReceivable || 0, 2));
            const lcAmount_0 = parseFloat((calculatedValues?.interestReceivable * (tradeData?.hd_cur_rate || 1)).toFixed(4));
            handleSetTradeData("fd_interest_lc", formatAmountsToDecimals(lcAmount_0 || 0, 2));

            // handleSetTradeData("tbill_price_fc", formatAmountsToDecimals(calculatedValues?.purchasePrice || 0, 2));
            // const lcAmount_1 = parseFloat((calculatedValues?.purchasePrice * (tradeData?.hd_cur_rate || 1)).toFixed(4));
            // handleSetTradeData("tbill_price_lc", formatAmountsToDecimals(lcAmount_1 || 0, 2));

            // handleSetTradeData("tbill_discount_fc", formatAmountsToDecimals(calculatedValues?.discountAmount || 0, 2));
            // const lcAmount_2 = parseFloat((calculatedValues?.discountAmount * (tradeData?.hd_cur_rate || 1)).toFixed(4));
            // handleSetTradeData("tbill_discount_lc", formatAmountsToDecimals(lcAmount_2 || 0, 2));

            // handleSetTradeData("tbill_yeild_maturity", formatAmountsToDecimals(calculatedValues?.yieldToMaturity || 0, 4));
            // handleSetTradeData("tbill_quantity", formatAmountsToDecimals(calculatedValues?.quantity || 0, 4));
        } catch (error) {
            console.log(error);
        }
    };

    const handleTradeFeeBlur = (id, field) => {
        try {
            const updatedData = [...tradeFees];
            const index = updatedData.findIndex(smi => smi._id === id);
            if (index === -1) return;

            let fee = { ...updatedData[index] };
            let value = fee[field];

            if (field === "rate") {
                value = formatNumber(formatStringToNumberV2(value));
                fee[field] = value;
            }

            if (["rate", "rate_type"].includes(field)) {
                const rateType = (fee["rate_type"] || "").toLowerCase();
                const rate = parseFloat(formatStringToNumberV2(fee["rate"]));
                const fcAmountBase = parseFloat(formatStringToNumberV2(tradeData?.hd_fc_amount || 0));
                const curRate = parseFloat(formatStringToNumberV2(tradeData?.hd_cur_rate || 1));

                let fcAmount = 0;
                if (rateType === "percentage") {
                    fcAmount = (rate / 100) * fcAmountBase;
                } else {
                    fcAmount = rate;
                }

                const lcAmount = fcAmount * curRate;

                fee.fee_amount_fc = formatNumber(fcAmount);
                fee.fee_amount_lc = formatNumber(lcAmount);
            }

            fee.changed_xx = "Y";
            updatedData[index] = fee;
            setTradeFees(updatedData);
        } catch (error) {
            console.error("handleTradeFeeBlur error:", error);
        }
    };


    const handleCloseNotifyDialog = () => {
        setIsNotifyDialogOpen(false);
    };

    const handleConfirm = async () => {
        try {
            if (confirmDialogAction === "completeTrade") {
                let validateResponse = null;
                try {
                    validateResponse = await newRequest.get(`/trade/validate/${tradeDocId}`, { timeout: 5000 });
                } catch (error) {
                    if (error.code === 'ECONNABORTED') {
                        console.error("Request timed out!");
                        showToast(t('requestTimedOut'), "error");
                    } else {
                        console.error("Other error:", error.message);
                        showToast(error.message, "error");
                    }
                }
                // console.log(`validateResponse  ${JSON.stringify(validateResponse, null, 2)}`);

                if (validateResponse.data.result_status === "error") {
                    setIsProcessing(false);
                    setIsConfirmDialogOpen(false);
                    setValidationMessagesResult(validateResponse.data);
                    setValidationMsgDialog(true);
                    return;
                }

                await newRequest.post("/trade/upd", {
                    trade_docid: tradeDocId,
                    security_type: tradeData?.security_type,
                    hd_status: objectToAction?.new_doc_status
                });

                try {
                    await newRequest.post(
                        "/trace/add",
                        {
                            trc_action_on: "Document",
                            trc_doc_docid: tradeData?._id,
                            trc_doc_no: tradeData?.hd_no,
                            trc_doc_type: "AM Trade",
                            trc_aent_code: "",
                            trc_ent_code: tradeData?.broker_code,
                            trc_action: "updated document status",
                            trc_remarks: `updated trade to ${objectToAction?.new_doc_status}`,
                            trc_tags: [`updated trade to ${objectToAction?.new_doc_status}`],
                        },
                    );
                } catch (error) {
                    console.log(error);
                }
                showToast(t('documentValidated', { param1: tradeData?.hd_no }), "success");
                await fetchTrade(tradeDocId);
            } else if (confirmDialogAction === "cancelTrade") {

            }
        } catch (err) {
            console.log(err);
        }
        setIsConfirmDialogOpen(false);
    };

    const handleCancel = () => {
        setIsConfirmDialogOpen(false);
    };

    const fetchProfileLimits = async () => {
        try {
            const limitsToCheck = ["AM2009", "AM2010", "AM2011"];
            const limits = await newRequest.post("/adProfile/checkValues", { module_code: "am", limit_codes: limitsToCheck });
            setProfileLimitValues(limits.data)
        } catch (error) {
            console.log(error)
        }
    }

    // Function to get limit_yn value by limit_code
    const getLimitValue = (limitCode) => {
        try {
            const limit = profileLimitValues.find(l => l.limit_code === limitCode);
            return limit ? limit.limit_yn : null;
        } catch (error) {
            console.log(error)
        }
    };

    const fetchBranches = async () => {
        try {
            const res = await newRequest.post("/orgUnit/findAll", { unit_status: "Active" });
            const options = res.data.map((branch) => ({
                value: branch?.unit_code,
                label: branch?.unit_name,
            }));
            setBranches(options);
        } catch (error) {
            console.error("Error fetching entity types:", error);
        }
    };

    const fetchFunds = async () => {
        try {
            const res = await newRequest.post("/fund/findAll", {
                fund_status: "Active",
                result_limit: 100
            });
            const options = res.data?.map((codes) => ({
                nav_per_unit: codes?.nav_per_unit || 0,
                fund_docid: codes?._id,
                value: codes?.fund_code,
                label: codes?.fund_name,
            }));

            setFunds(options);
        } catch (error) {
            console.error("Error fetching defined sectors :", error);
        }
    };

    const fetchCurrencies = async () => {
        try {
            const res = await newRequest.get("/glCurrency/findAll");
            const options = res.data.map((currency) => ({
                value: currency?.cur_code,
                label: currency?.cur_code,
            }));
            setCurrencies(options);
        } catch (error) {
            console.error("Error fetching entity types:", error);
        }
    };

    const fetchDefinedFees = async () => {
        try {
            const res = await newRequest.post("/sysCode/findAll", { sys_type: "Trade Fees" });
            const options = res.data?.map((codes) => ({
                sys_flex1: codes?.sys_flex1,
                sys_flex2: codes?.sys_flex2,
                fee_type: codes?.sys_grouping,
                value: codes?.sys_code,
                label: codes?.sys_name,
            }));
            setDefinedFees(options);
        } catch (error) {
            console.error("Error fetching fund types :", error);
        }
    };

    const fetchSecurities = async () => {
        try {
            const res = await newRequest.post("/amsec/findAll", {
                sec_status: "Active",
                result_limit: 100
            });
            const options = res.data?.map((codes) => ({
                sec_alias: codes?.sec_alias,
                asset_class_code: codes?.asset_class_code,
                security_type: codes?.security_type,
                security_docid: codes?._id,
                value: codes?.sec_code,
                label: codes?.sec_name,
            }));

            setSecurities(options);
        } catch (error) {
            console.error("Error fetching defined sectors :", error);
        }
    };

    const fetchDocumentAttachments = async (docType, docid) => {
        try {
            const res = await newRequest.post(
                "/files/findDocFiles",
                {
                    fl_doc_type: docType,
                    fl_parent_doc_id: docid,
                });

            setAttachmentsData(res.data);
        } catch (err) {
            console.log(err);
        }
    };

    const fetchPriorityLevels = async () => {
        try {
            const res = await newRequest.post("/sysCode/findAll", { sys_type: "AM Priority Level" });
            const options = res.data?.map((codes) => ({
                value: codes?.sys_code,
                label: codes?.sys_name,
            }));

            setPriorityLevels(options);
        } catch (error) {
            console.error("Error fetching security types :", error);
        }
    };

    const fetchDetails = () => {
        try {
            const tradeTypes = ["Buy", "Sell", "Roll Over", "Redeem", "Transfer In", "Transfer Out"]?.map((code) => ({
                value: code,
                label: code,
            }));
            setTradeTypes(tradeTypes);

            const settlementStatuses = ["Pending", "Settled", "Failed", "Manual Intervention"]?.map((code) => ({
                value: code,
                label: code,
            }));
            setSettlementStatuses(settlementStatuses);

            const conventions = ["Actual/Actual", "30/360", "Actual/360", "Actual/365"]?.map((code) => ({
                value: code,
                label: code,
            }));
            setConventions(conventions);

            const rtypes = ['Percentage', 'Fixed Amount']?.map((code) => ({
                value: code,
                label: code,
            }));
            setRateTypes(rtypes);

            const mtypes = ["Primary", "Secondary"]?.map((code) => ({
                value: code,
                label: code,
            }));
            setMarketTypes(mtypes);

            const freqs = ["Monthly", "Quarterly", "Semi Annual", "Annual"]?.map((code) => ({
                value: code,
                label: code,
            }));
            setCouponFrequencies(freqs);

        } catch (error) {
            console.error("Error :", error);
        }
    };

    const fetchTrade = async (doc_id, firstTime = false) => {
        try {
            if (doc_id && doc_id !== "new") {
                if (firstTime) {
                    setIsLoading(true);
                }
                const res = await newRequest.get(`/trade/find/${doc_id}`);

                if (res.data) {
                    const formattedData = {
                        ...res.data,
                        hd_gl_date: res.data?.hd_gl_date ? moment(res.data?.hd_gl_date).format("YYYY-MM-DD") : null,
                        hd_cur_rate: formatAmountsToDecimals(res.data?.hd_cur_rate || 0, 6),
                        hd_fc_amount: formatAmountsToDecimals(res.data?.hd_fc_amount || 0, 2),
                        hd_lc_amount: formatAmountsToDecimals(res.data?.hd_lc_amount || 0, 2),
                        gross_fc_amount: formatAmountsToDecimals(res.data?.gross_fc_amount || 0, 2),
                        gross_lc_amount: formatAmountsToDecimals(res.data?.gross_lc_amount || 0, 2),

                        equity_quantity: formatAmountsToDecimals(res.data?.equity_quantity || 0, 4),
                        equity_price: formatAmountsToDecimals(res.data?.equity_price || 0, 2),

                        bond_quantity: formatAmountsToDecimals(res.data?.bond_quantity || 0, 4),
                        maturity_value: formatAmountsToDecimals(res.data?.maturity_value || 0, 2),
                        clean_price_fc: formatAmountsToDecimals(res.data?.clean_price_fc || 0, 2),
                        clean_price_lc: formatAmountsToDecimals(res.data?.clean_price_lc || 0, 2),
                        accrued_interest: formatAmountsToDecimals(res.data?.accrued_interest || 0, 2),
                        face_value_fc: formatAmountsToDecimals(res.data?.face_value_fc || 0, 2),
                        face_value_lc: formatAmountsToDecimals(res.data?.face_value_lc || 0, 2),

                        coupon_rate: formatAmountsToDecimals(res.data?.coupon_rate || 0, 6),
                        last_coupon_date: res.data?.last_coupon_date ? moment(res.data?.last_coupon_date).format("YYYY-MM-DD") : null,
                        settlement_date: res.data?.settlement_date ? moment(res.data?.settlement_date).format("YYYY-MM-DD") : null,
                        coupon_start_date: res.data?.coupon_start_date ? moment(res.data?.coupon_start_date).format("YYYY-MM-DD") : null,
                        coupon_maturity_date: res.data?.coupon_maturity_date ? moment(res.data?.coupon_maturity_date).format("YYYY-MM-DD") : null,

                        tbill_tenor: formatAmountsToDecimals(res.data?.tbill_tenor || 0, 0),
                        tbill_discount_rate: formatAmountsToDecimals(res.data?.tbill_discount_rate || 0, 4),
                        tbill_discount_fc: formatAmountsToDecimals(res.data?.tbill_discount_fc || 0, 2),
                        tbill_discount_lc: formatAmountsToDecimals(res.data?.tbill_discount_lc || 0, 2),
                        tbill_yeild_maturity: formatAmountsToDecimals(res.data?.tbill_yeild_maturity || 0, 4),
                        tbill_price_fc: formatAmountsToDecimals(res.data?.tbill_price_fc || 0, 2),
                        tbill_price_lc: formatAmountsToDecimals(res.data?.tbill_price_lc || 0, 2),
                        tbill_quantity: formatAmountsToDecimals(res.data?.tbill_quantity || 0, 4),
                        tbill_start_date: res.data?.tbill_start_date ? moment(res.data?.tbill_start_date).format("YYYY-MM-DD") : null,
                        tbill_maturity_date: res.data?.tbill_maturity_date ? moment(res.data?.tbill_maturity_date).format("YYYY-MM-DD") : null,

                        fd_interest_rate: formatAmountsToDecimals(res.data?.fd_interest_rate || 0, 6),
                        fd_principal_fc: formatAmountsToDecimals(res.data?.fd_principal_fc || 0, 2),
                        fd_principal_lc: formatAmountsToDecimals(res.data?.fd_principal_lc || 0, 2),
                        fd_interest_fc: formatAmountsToDecimals(res.data?.fd_interest_fc || 0, 2),
                        fd_interest_lc: formatAmountsToDecimals(res.data?.fd_interest_lc || 0, 2),
                        fd_tenor_in_days: formatAmountsToDecimals(res.data?.fd_tenor_in_days || 0, 0),
                        fd_start_date: res.data?.fd_start_date ? moment(res.data?.fd_start_date).format("YYYY-MM-DD") : null,
                        fd_maturity_date: res.data?.fd_maturity_date ? moment(res.data?.fd_maturity_date).format("YYYY-MM-DD") : null,

                        execution_price: formatAmountsToDecimals(res.data?.execution_price || 0, 2),
                        executed_quantity: formatAmountsToDecimals(res.data?.executed_quantity || 0, 4),
                        execution_fc_amount: formatAmountsToDecimals(res.data?.execution_fc_amount || 0, 2),
                        execution_lc_amount: formatAmountsToDecimals(res.data?.execution_lc_amount || 0, 2),
                        execution_date: res.data?.execution_date ? moment(res.data?.execution_date).format("YYYY-MM-DD") : null,

                    };

                    // console.log(`formattedData... ${JSON.stringify(formattedData, null, 2)}`);

                    setTradeData(formattedData);

                    const formattedFees = res.data?.trade_fees_xx?.map(fee => ({
                        ...fee,
                        rate: formatAmountsToDecimals(fee?.rate, 6),
                        fee_amount_fc: formatAmountsToDecimals(fee?.fee_amount_fc, 2),
                        fee_amount_lc: formatAmountsToDecimals(fee?.fee_amount_lc, 2),

                    }));
                    setTradeFees(formattedFees);

                    setTradeDocId(res.data._id);
                    setDocumentEnabled(res.data.document_enabled_xx);
                    setNextAction(res.data.next_action_xx);

                    if (res.data?.security_docid) {
                        setSelectedSecurity({
                            sec_alias: res.data?.security_details_xx?.sec_alias,
                            asset_class_code: res.data?.security_details_xx?.asset_class_code,
                            security_type: res.data?.security_details_xx?.security_type,
                            security_docid: res.data?.security_details_xx?._id,
                            value: res.data?.security_details_xx?.sec_code,
                            label: res.data?.security_details_xx?.sec_name,
                        });
                    } else {
                        setSelectedSecurity(null);
                    }

                    if (res.data?.fund_docid) {
                        setSelectedFund({
                            nav_per_unit: res.data?.fund_nav_per_unit_xx || 0,
                            fund_docid: res.data?.fund_docid,
                            value: res.data?.fund_code_xx,
                            label: res.data?.fund_name_xx,
                        });
                    } else {
                        setSelectedFund(null);
                    }

                    if (res.data?.broker_details_xx) {
                        setSelectedBroker({
                            ent_docid: res.data?.broker_details_xx?._id,
                            ent_occupation_xx: res.data?.broker_details_xx?.ent_occupation_xx,
                            ent_email: res.data?.broker_details_xx?.ent_email,
                            ent_phone_no: res.data?.broker_details_xx?.ent_phone_no,
                            ent_photo_url: res.data?.broker_details_xx?.ent_photo_url,
                            ent_status: res.data?.broker_details_xx?.ent_status,
                            aent_name_xx: res.data?.broker_details_xx?.aent_name_xx,
                            ent_code: res.data?.broker_details_xx?.ent_code,
                            ent_aent_code: res.data?.broker_details_xx?.ent_aent_code,
                            ent_name: res.data?.broker_details_xx?.ent_name,
                            value: res.data?.broker_details_xx?.ent_code,
                            label: (
                                <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", marginRight: "5px" }}>
                                    {res.data?.broker_details_xx?.ent_name}
                                </div>
                            ),
                        });
                    } else {
                        setSelectedBroker(null);
                    }

                    if (res.data.document_enabled_xx === "Y") {
                        await callDetailsFunction();
                    }
                    await fetchTrace(res.data?.hd_no);
                    fetchDocumentAttachments("am trade", res.data._id);
                }
            }
        } catch (err) {
            console.log(err);
        } finally {
            if (firstTime) {
                setIsLoading(false);
            }
        }
    };


    const handleTransmitTrade = async (e) => {
        try {
            let transmitResponse = null;
            try {
                transmitResponse = await newRequest.get(`/trade/transmit/${tradeDocId}`, { timeout: 5000 });
            } catch (error) {
                if (error.code === 'ECONNABORTED') {
                    console.error("Request timed out!");
                    showToast(t('requestTimedOut'), "error");
                } else {
                    console.error("Other error:", error.message);
                    showToast(error.message, "error");
                }
            }
            console.log(`transmitResponse  ${JSON.stringify(transmitResponse, null, 2)}`);

            if (transmitResponse.data.result_status === "error") {
                setIsProcessing(false);
                setIsConfirmDialogOpen(false);
                setValidationMessagesResult(transmitResponse.data);
                setValidationMsgDialog(true);
                return;
            }

            const res = await newRequest.post("/trade/upd", {
                trade_docid: tradeDocId,
                security_type: tradeData?.security_type,
                hd_status: "Transmitted"
            });

            try {
                const res = await newRequest.post(
                    "/trace/add",
                    {
                        trc_action_on: "Document",
                        trc_doc_docid: tradeData?._id,
                        trc_doc_no: tradeData?.hd_no,
                        trc_doc_type: "AM Trade",
                        trc_ent_code: tradeData?.broker_code,
                        trc_action: "updated document status",
                        trc_remarks: "order transmitted to broker",
                        trc_tags: ["order transmitted to broker"],
                    },
                );
            } catch (error) {
                console.log(error);
            }
            showToast(t('documentTransmitted', { param1: tradeData?.hd_no, param2: selectedBroker?.ent_name }), "success");
            await fetchTrade(tradeDocId);
        } catch (error) {
            console.log(error);
        }
    }


    const saveRecord = async (e) => {
        try {

            if (!selectedBroker) {
                setNotifyDialogTitle("Note!");
                setNotifyDialogText(`Please select broker!`);
                setIsNotifyDialogOpen(true);
                return;
            }

            if (!selectedFund) {
                setNotifyDialogTitle("Note!");
                setNotifyDialogText(`Please select fund!`);
                setIsNotifyDialogOpen(true);
                return;
            }

            if (!tradeData?.security_docid) {
                setNotifyDialogTitle("Note!");
                setNotifyDialogText(`Please select security!`);
                setIsNotifyDialogOpen(true);
                return;
            }

            if (!tradeData?.trade_type) {
                setNotifyDialogTitle("Note!");
                setNotifyDialogText(`Please select trade type!`);
                setIsNotifyDialogOpen(true);
                if (tradeTypeRef.current) {
                    tradeTypeRef.current.focus();
                }
                return;
            }


            const formattedData = {
                ...tradeData,
                broker_docid: selectedBroker?.ent_docid,
                broker_code: selectedBroker?.ent_code,
                fund_docid: selectedFund?.fund_docid,
                hd_cur_rate: parseFloat(formatStringToNumberV2(tradeData?.hd_cur_rate || 0, 6)),
                gross_fc_amount: parseFloat(formatStringToNumberV2(tradeData?.gross_fc_amount || 0, 2)) || 0,
                gross_lc_amount: parseFloat(formatStringToNumberV2(tradeData?.gross_lc_amount || 0, 2)) || 0,

                // EQUITY
                equity_quantity: parseFloat(formatStringToNumberV2(tradeData?.equity_quantity || 0, 4)) || 0,
                equity_price: parseFloat(formatStringToNumberV2(tradeData?.equity_price || 0, 2)) || 0,

                // TREASURY BILLS
                tbill_tenor: parseFloat(formatStringToNumberV2(tradeData?.tbill_tenor || 0, 0)) || 0,
                tbill_discount_rate: parseFloat(formatStringToNumberV2(tradeData?.tbill_discount_rate || 0, 6)) || 0,
                tbill_discount_fc: parseFloat(formatStringToNumberV2(tradeData?.tbill_discount_fc || 0, 2)) || 0,
                tbill_discount_lc: parseFloat(formatStringToNumberV2(tradeData?.tbill_discount_lc || 0, 2)) || 0,
                tbill_yeild_maturity: parseFloat(formatStringToNumberV2(tradeData?.tbill_yeild_maturity || 0, 4)) || 0,
                tbill_quantity: parseFloat(formatStringToNumberV2(tradeData?.tbill_quantity || 0, 4)) || 0,
                tbill_price_fc: parseFloat(formatStringToNumberV2(tradeData?.tbill_price_fc || 0, 2)) || 0,
                tbill_price_lc: parseFloat(formatStringToNumberV2(tradeData?.tbill_price_lc || 0, 2)) || 0,

                // BONDS
                coupon_rate: parseFloat(formatStringToNumberV2(tradeData?.coupon_rate || 0, 6)) || 0,
                bond_quantity: parseFloat(formatStringToNumberV2(tradeData?.bond_quantity || 0, 4)) || 0,
                clean_price_fc: parseFloat(formatStringToNumberV2(tradeData?.clean_price_fc || 0, 2)) || 0,
                clean_price_lc: parseFloat(formatStringToNumberV2(tradeData?.clean_price_lc || 0, 2)) || 0,
                accrued_interest: parseFloat(formatStringToNumberV2(tradeData?.accrued_interest || 0, 2)) || 0,
                face_value_fc: parseFloat(formatStringToNumberV2(tradeData?.face_value_fc || 0, 2)) || 0,
                face_value_lc: parseFloat(formatStringToNumberV2(tradeData?.face_value_lc || 0, 2)) || 0,

                // FIXED DEPOSITS
                fd_interest_rate: parseFloat(formatStringToNumberV2(tradeData?.fd_interest_rate || 0, 6)) || 0,
                fd_principal_fc: parseFloat(formatStringToNumberV2(tradeData?.fd_principal_fc || 0, 2)) || 0,
                fd_principal_lc: parseFloat(formatStringToNumberV2(tradeData?.fd_principal_lc || 0, 2)) || 0,
                fd_interest_fc: parseFloat(formatStringToNumberV2(tradeData?.fd_interest_fc || 0, 2)) || 0,
                fd_interest_lc: parseFloat(formatStringToNumberV2(tradeData?.fd_interest_lc || 0, 2)) || 0,

                execution_price: parseFloat(formatStringToNumberV2(tradeData?.execution_price || 0, 2)) || 0,
                executed_quantity: parseFloat(formatStringToNumberV2(tradeData?.executed_quantity || 0, 4)) || 0,
                execution_fc_amount: parseFloat(formatStringToNumberV2(tradeData?.execution_fc_amount || 0, 2)) || 0,
                execution_lc_amount: parseFloat(formatStringToNumberV2(tradeData?.execution_lc_amount || 0, 2)) || 0,

                hd_fc_amount: parseFloat(formatStringToNumberV2(tradeData?.hd_fc_amount || 0, 4)) || 0,
                hd_lc_amount: parseFloat(formatStringToNumberV2(tradeData?.hd_lc_amount || 0, 4)) || 0,
            };

            // console.log(`formattedData ${JSON.stringify(formattedData, null, 2)}`);

            if (tradeDocId === "new" || tradeDocId === undefined) {
                // generate transaction number
                const numGen = await newRequest.post("/orgNumgen/gen", { gen_type: "AM Trade", },);

                if (!numGen?.data && !tradeData?.hd_no) {
                    setNotifyDialogTitle("Note!");
                    setNotifyDialogText(`Number generation for trades not set!`);
                    setIsNotifyDialogOpen(true);
                    return;
                }

                // console.log(`inserting ${JSON.stringify({ ...formattedData, hd_no: numGen?.data }, null, 2)}`);
                const res = await newRequest.post("/trade/add", { ...formattedData, hd_no: numGen?.data });
                if (res.data?.msg === "added") {
                    setNotifyDialogTitle(t('success'));
                    setNotifyDialogText(t('successSaved', { param1: numGen?.data }));
                    setIsNotifyDialogOpen(true);
                    // console.log(`fetching... ${JSON.stringify(res.data, null, 2)}`);
                    await fetchTrade(res.data?.doc?._id);
                    navigate(`/trade/${res.data?.doc?._id}`, { replace: true });
                } else if (res.data?.msg === "exists") {
                    showToast(t('transactionExists', { param1: res.data?.doc?.hd_no }), "success");
                } else {
                    showToast(res.data?.msg, "error");
                }
            } else {

                await newRequest.post("/trade/upd/", {
                    trade_docid: tradeData?._id,
                    security_type: tradeData?.security_type,
                    ...formattedData
                });

                // get changed fees
                const changedFees = tradeFees.filter((obj) => obj.changed_xx === "Y");
                // Loop through each object in the array
                for (let i = 0; i < changedFees.length; i++) {
                    const formattedFee = {
                        ...changedFees[i],
                        rate: formatStringToNumberV2(changedFees[i].rate, 4),
                        rate_type: changedFees[i].rate_type,
                        fee_amount_fc: formatStringToNumberV2(changedFees[i].fee_amount_fc, 2),
                        fee_amount_lc: formatStringToNumberV2(changedFees[i].fee_amount_lc, 2),
                    };
                    await newRequest.put(`/trade/updFee/${changedFees[i]?._id}`, formattedFee);
                }

                setNotifyDialogTitle(t('success'));
                setNotifyDialogText(t('successSaved', { param1: tradeData?.hd_no }));
                setIsNotifyDialogOpen(true);
            }
        } catch (err) {
            setIsLoading(false);
            console.log(err);
        }
    };

    const fetchTrace = async (tradeNo) => {
        try {
            const res = await newRequest.post(
                "/trace/findDoc",
                {
                    trc_doc_type: "AM Trade",
                    trc_doc_no: tradeNo
                }
            );
            setTraceData(res.data);
        } catch (err) {
            console.log(err);
        }
    };


    const callDetailsFunction = async () => {
        try {
            await fetchFunds();
            await fetchSecurities();
            await fetchBranches();
            await fetchCurrencies();
            await fetchPriorityLevels();
            await fetchDefinedFees();
            fetchDetails();
        } catch (err) {
            console.log(err);
        }
    };

    const handleSetTradeData = (name, value) => {
        setTradeData((prev) => {
            return { ...prev, [name]: value };
        });
    };

    const recalculateAmounts = () => {
        try {
            let fcAmount = 0;
            let lcAmount = 0;
            let accruedInterest = 0;
            let maturityValue = 0;

            const assetClass = tradeData?.security_type;
            const equityQuantity = parseFloat(formatStringToNumberV2(tradeData?.equity_quantity || 0, 4));
            const equityPrice = parseFloat(formatStringToNumberV2(tradeData?.equity_price || 0, 2));
            const rate = parseFloat(tradeData?.hd_cur_rate || 1);

            switch (assetClass) {
                case "Equity":
                    fcAmount = equityQuantity * equityPrice;
                    break;

                case "Bond": {
                    const cleanValue = equityQuantity * (equityPrice / 100);
                    const marketType = tradeData?.market_type || "Primary";

                    accruedInterest = (marketType === "Secondary")
                        ? calculateAccruedInterest({
                            couponRate: parseFloat(tradeData?.coupon_rate || 0),
                            faceValue: equityQuantity,
                            lastCouponDate: tradeData?.last_coupon_date,
                            settlementDate: tradeData?.settlement_date,
                            dayCountConvention: tradeData?.day_count_convention || "Actual/Actual",
                            marketType,
                        }) : 0;

                    fcAmount = cleanValue + accruedInterest;
                    break;
                }

                case "T-Bill": {
                    const discountedValue = equityQuantity * (1 - equityPrice / 100);
                    accruedInterest = 0; // No accrued interest for T-Bills
                    fcAmount = discountedValue;
                    break;
                }

                case "Deposit": {
                    const principal = equityQuantity;
                    const interestRate = parseFloat(tradeData?.fd_interest_rate || 0);
                    const tenor = parseFloat(tradeData?.tenor || 0); // in days

                    maturityValue = principal * (1 + (interestRate * tenor) / 365);
                    fcAmount = principal;
                    break;
                }

                default:
                    console.warn("Unknown asset class for trade calculation");
            }

            lcAmount = parseFloat((fcAmount * (rate || 1)).toFixed(4));

            console.log(`fcAmount ... ${fcAmount}`);
            console.log(`lcAmount ... ${lcAmount}`);
            console.log(`accruedInterest ... ${accruedInterest}`);
            console.log(`maturityValue ... ${maturityValue}`);

            return {
                fcAmount,
                lcAmount,
                accruedInterest,
                maturityValue,
            };
        } catch (err) {
            console.error("Error in recalculateAmounts:", err);
            return { fcAmount: 0, lcAmount: 0 };
        }
    };


    const recalculateSettlement = () => {
        try {
            let fcAmount = 0;
            let lcAmount = 0;
            let accruedInterest = 0;
            let maturityValue = 0;

            const assetClass = tradeData?.security_type;

            const executedQuantity = parseFloat(formatStringToNumberV2(tradeData?.executed_quantity || 0, 4));
            const executionPrice = parseFloat(formatStringToNumberV2(tradeData?.execution_price || 0, 2));

            const rate = parseFloat(tradeData?.hd_cur_rate || 1);

            switch (assetClass) {
                case "Equity":
                    fcAmount = executedQuantity * executionPrice;
                    break;

                case "Bond":
                    {
                        const cleanValue = executedQuantity * (executionPrice / 100);
                        accruedInterest = calculateAccruedInterest({
                            couponRate: parseFloat(tradeData?.coupon_rate || 0),
                            faceValue: executedQuantity,
                            lastCouponDate: tradeData?.last_coupon_date,
                            settlementDate: tradeData?.settlement_date,
                            dayCountConvention: tradeData?.day_count_convention || "Actual/Actual",
                        });
                        fcAmount = cleanValue + accruedInterest;
                    }
                    break;

                case "T-Bill":
                    {
                        const discountedValue = executedQuantity * (1 - executionPrice / 100);
                        accruedInterest = calculateAccruedInterest({
                            couponRate: parseFloat(tradeData?.coupon_rate || 0),
                            faceValue: executedQuantity,
                            lastCouponDate: tradeData?.last_coupon_date,
                            settlementDate: tradeData?.settlement_date,
                            dayCountConvention: tradeData?.day_count_convention || "Actual/Actual",
                        });
                        fcAmount = discountedValue + accruedInterest;
                    }
                    break;

                case "Deposit":
                    {
                        const principal = executedQuantity;
                        const interestRate = parseFloat(tradeData?.fd_interest_rate || 0);
                        const tenor = parseFloat(tradeData?.tenor || 0); // in days

                        maturityValue = principal * (1 + (interestRate * tenor) / 365);
                        fcAmount = principal;
                    }
                    break;

                default:
                    console.warn("Unknown asset class for trade calculation");
            }

            lcAmount = parseFloat((fcAmount * rate).toFixed(4));

            return {
                fcAmount,
                lcAmount,
                accruedInterest,
                maturityValue,
            };
        } catch (err) {
            console.log("Error in recalculateAmounts:", err);
            return { fcAmount: 0, lcAmount: 0 };
        }
    };

    useEffect(() => {
        function handleClickOutside(event) {
            if (actionsMenuRef.current && !actionsMenuRef.current.contains(event.target)) {
                setAdditionalActionsMenu(false);
            }
        }

        // Add event listener
        document.addEventListener('mousedown', handleClickOutside);

        // Clean up the event listener
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    // calculate total fees
    useEffect(() => {
        let fcTotal = 0;
        let lcTotal = 0;
        for (const item of tradeFees) {
            const fc = parseFloat(formatStringToNumberV2(item?.fee_amount_fc || 0)) || 0;
            const lc = parseFloat(formatStringToNumberV2(item?.fee_amount_lc || 0)) || 0;
            fcTotal += isNaN(fc) ? 0 : fc;
            lcTotal += isNaN(lc) ? 0 : lc;

        }
        setTotalFeesFc(fcTotal);
        setTotalFeesLc(lcTotal);
    }, [tradeFees]);


    useEffect(() => {
        if (docid) {
            setTradeDocId(docid);
        }
    }, [docid]);

    useEffect(() => {
        if (tradeDocId === "new" || tradeDocId === undefined) {
            setTradeDocId("new");
            setDocumentEnabled("Y");
            callDetailsFunction();
            if (brokerRef.current) {
                brokerRef.current.focus();
            }

            setTradeData({
                hd_status: "New",
                hd_priority: "Normal",
                hd_gl_date: moment().format("YYYY-MM-DD"),
                hd_biz_unit: currentUser?.biz_unit_code_xx,
                hd_cur_code: currentUser?.currency_code_xx,
                hd_cur_rate: 1,
                hd_fc_amount: 0,
                hd_lc_amount: 0,
                gross_fc_amount: 0,
                gross_lc_amount: 0,
                equity_quantity: 0,
                bond_quantity: 0,
                equity_price: 0,
                coupon_rate: 0,
                day_count_convention: "Actual/Actual",
                fd_principal_fc: 0,
                fd_principal_lc: 0,
                fd_interest_rate: 0,
                fd_tenor_in_days: 0,
                accrued_interest: 0,
                maturity_value: 0,
                clean_price_fc: 0,
                clean_price_lc: 0,
                tbill_quantity: 1,
                execution_price: 0,
                executed_quantity: 0,
                settlement_status: "Pending",
                market_type: "Primary",
            })
        } else {
            fetchTrade(tradeDocId, true);
        }
        fetchProfileLimits();
    }, [tradeDocId]);

    return (
        <motion.div
            className="am-trade"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1, transition: { duration: 1 } }}
            exit={{ opacity: 0, transition: { duration: 1 } }}
        >
            {isLoading ? (
                <div className="no-content">
                    <ScaleLoader
            color="var(--primary)"
            height={50}
            radius={8}
            width={4}
          />
                </div>
            ) : (
                <div className="am-trade-main-wrapper">
                    <div className="am-trade-navbar">
                        <div className="am-trade-navbar-left">
                            <span className="main-title">{tradeData?.hd_no || t('newTrade')}</span>
                            <span className="sub-title">{tradeData?._id}</span>
                            <span className="sub-title">{tradeDocId !== "new" && `${tradeData?.hd_status}`}</span>
                        </div>
                        <div className="am-trade-navbar-right">
                            {documentEnabled === "Y" && (
                                <CustomLoadingButton
                                    currentTheme={currentTheme}
                                    iconPosition="end"
                                    borderRadiusType="left"
                                    endIcon={<MdRefresh />}
                                    onClick={async () => {
                                        try {
                                            await fetchTrade(tradeDocId);
                                            setRefreshKey(prevKey => prevKey + 1);
                                        } catch (error) {
                                            console.log(error);
                                        }
                                    }}
                                >
                                    {t('refresh')}
                                </CustomLoadingButton>
                            )}

                            {tradeData?.hd_status === "Completed" && (
                                <CustomLoadingButton
                                    currentTheme={currentTheme}
                                    iconPosition="end"
                                    borderRadiusType="none"
                                    endIcon={<RiSendPlaneFill />}
                                    onClick={handleTransmitTrade}>
                                    {t('transmit')}
                                </CustomLoadingButton>
                            )}

                            {tradeDocId !== "new" && nextAction !== "None" && (
                                <>
                                    <CustomLoadingButton
                                        currentTheme={currentTheme}
                                        iconPosition="end"
                                        borderRadiusType="none"
                                        endIcon={<MdDragIndicator />}
                                        onClick={() => {
                                            try {
                                                let action_text = "";
                                                let new_doc_status = tradeData?.hd_status;
                                                switch (tradeData?.hd_status) {
                                                    case "New":
                                                        action_text = `Do you want to Complete this transaction?`;
                                                        setConfirmDialogAction("completeTrade");
                                                        new_doc_status = "Completed";
                                                        break;
                                                    case "Completed":
                                                        action_text = `Do you want to Approve this transaction?`;
                                                        setConfirmDialogAction("approveTrade");
                                                        new_doc_status = "Approved";
                                                        break;
                                                    case "Approved":
                                                        action_text = `Do you want to cancel this transaction?`;
                                                        setConfirmDialogAction("cancelTrade");
                                                        new_doc_status = "Cancelled";
                                                        break;
                                                    default:
                                                        action_text = "";
                                                        new_doc_status = "";
                                                }
                                                setObjectToAction({
                                                    object_id: tradeData._id,
                                                    action_text: action_text,
                                                    new_doc_status,
                                                });
                                                setIsConfirmDialogOpen(true);
                                            } catch (error) {
                                                console.log(error);
                                            }
                                        }}
                                    >
                                        {nextAction}
                                    </CustomLoadingButton>
                                </>
                            )}
                            {documentEnabled === "Y" && (
                                <CustomLoadingButton
                                    currentTheme={currentTheme}
                                    iconPosition="end"
                                    borderRadiusType="none"
                                    endIcon={<MdSave />} onClick={saveRecord}>
                                    {t('save')}
                                </CustomLoadingButton>
                            )}
                            {tradeDocId !== "new" && (
                                <CustomLoadingButton
                                    currentTheme={currentTheme}
                                    iconPosition="end"
                                    borderRadiusType="none"
                                    endIcon={<IoDocumentTextSharp />}
                                    onClick={() => setReportsDialogOpen(true)}>
                                    {t('reports')}
                                </CustomLoadingButton>
                            )}
                            <CustomLoadingButton
                                currentTheme={currentTheme}
                                iconPosition="end"
                                borderRadiusType="right"
                                endIcon={<MdClose />}
                                onClick={() => navigate(-1)}>
                                {t('close')}
                            </CustomLoadingButton>
                            <div className="icon-container"
                                ref={actionsMenuRef}
                                onClick={(e) => {
                                    try {
                                        e.stopPropagation();
                                        setAdditionalActionsMenu(!additionalActionsMenu)
                                    } catch (error) {
                                        console.log(error)
                                    }
                                }}>
                                <MdOutlineMenuOpen className="icon" />
                                {additionalActionsMenu && (
                                    <div className="dropdown">
                                        {tradeData?.hd_status === "Transmitted" &&
                                            <div className="dropdown-item"
                                                onClick={() => {
                                                    try {
                                                        if (getLimitValue("AM2011") === "N") {
                                                            setNotifyDialogTitle("Note!");
                                                            setNotifyDialogText(`AM2011: You are not authorized to settle trades!`);
                                                            setIsNotifyDialogOpen(true);
                                                            return;
                                                        }

                                                        if (["Equity"].includes(tradeData?.security_type)) {
                                                            handleSetTradeData("execution_price", formatAmountsToDecimals(tradeData?.equity_price || 0, 2));
                                                            handleSetTradeData("executed_quantity", formatAmountsToDecimals(tradeData?.equity_quantity || 0, 4));
                                                            handleSetTradeData("execution_fc_amount", formatAmountsToDecimals(tradeData?.hd_fc_amount || 0, 2));
                                                            handleSetTradeData("execution_lc_amount", formatAmountsToDecimals(tradeData?.hd_lc_amount || 0, 2));
                                                        } else if (["Bond", "T-Bill"].includes(tradeData?.security_type)) {
                                                            handleSetTradeData("execution_price", formatAmountsToDecimals(tradeData?.face_value_fc || 0, 2));
                                                            handleSetTradeData("executed_quantity", formatAmountsToDecimals(tradeData?.bond_quantity || 0, 4));
                                                            handleSetTradeData("execution_fc_amount", formatAmountsToDecimals(tradeData?.hd_fc_amount || 0, 2));
                                                            handleSetTradeData("execution_lc_amount", formatAmountsToDecimals(tradeData?.hd_lc_amount || 0, 2));
                                                        }

                                                        setSettleTradeDialogOpen(true);
                                                    } catch (error) {
                                                        console.log(error)
                                                    }
                                                }}>{t('settleTrade')}</div>}
                                        {["Transmitted", "Settled"].includes(tradeData?.hd_status) &&
                                            <div className="dropdown-item"
                                                onClick={() => {
                                                    try {
                                                        if (getLimitValue("AM2014") === "N") {
                                                            setNotifyDialogTitle("Note!");
                                                            setNotifyDialogText(`AM2014: You are not authorized to cancel trades!`);
                                                            setIsNotifyDialogOpen(true);
                                                            return;
                                                        }
                                                        const action_text = `Are you sure you want to CANCEL this trade?`;
                                                        setObjectToAction({
                                                            object_id: tradeData?._id,
                                                            action_text: action_text,
                                                        });
                                                        setConfirmDialogAction("cancelTrade");
                                                        setIsConfirmDialogOpen(true);
                                                    } catch (error) {
                                                        console.log(error)
                                                    }
                                                }}
                                            >{t('cancel')}</div>}
                                        {tradeData?.hd_status === "Transmitted" &&
                                            <div className="dropdown-item"
                                                onClick={() => {
                                                    try {
                                                        // if (getLimitValue("GB1006") === "N") {
                                                        //     setNotifyDialogTitle("Note!");
                                                        //     setNotifyDialogText(`GB1006: You are not authorized to CLOSE ${entName}!`);
                                                        //     setIsNotifyDialogOpen(true);
                                                        //     return;
                                                        // }
                                                        // const action_text = `Are you sure you want to CLOSE ${entName}?. Please note this action is irrevasible. A CLOSED account CANNOT be reopened. All transactions related to this entity that are in progress cannot be approved.`;
                                                        // setObjectToAction({
                                                        //     object_id: entityId,
                                                        //     action_text: action_text,
                                                        // });
                                                        // setConfirmDialogAction("closeAccount");
                                                        // setIsConfirmDialogOpen(true);
                                                    } catch (error) {
                                                        console.log(error)
                                                    }
                                                }}
                                            >{t('review')}</div>}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="content-summary-wrapper">
                        <div className="content-wrapper">
                            <div className="tabs-container">
                                <div className="tab-header">
                                    {topMenus?.map((tab, index) => (
                                        <div
                                            key={index}
                                            className={`${activeTab === index ? 'tab active' : 'tab'}`}
                                            onClick={() => handleTabClick(index)}
                                        >
                                            <span className={`${activeTab === index ? 'tab-icon active' : 'tab-icon'}`}>
                                                {tab.menu_icon}
                                            </span>
                                            <span className={`${activeTab === index ? 'tab-title active' : 'tab-title'}`}>{tab.menu_title}</span>
                                            {tab.menu_count > 0 && <Badge badgeContent={tab.menu_count} showZero
                                                className={activeTab === index ? "tab-badge active" : "tab-badge"} />}
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <div className="trade-content-details">
                                {/* Summary Information */}
                                {activeTab === 0 &&
                                    <>
                                        {documentEnabled === "N" &&
                                            <div className="content-details-row approved-doc">
                                                <span>{`${t('no').toUpperCase()}: ${tradeData?.hd_no}`}</span>
                                                <span>{`${t('bizUnit').toUpperCase()}: ${tradeData?.hd_biz_unit}`}</span>
                                                <span>{`${t('status').toUpperCase()}: ${tradeData?.hd_status}`}</span>
                                            </div>}
                                        {/* received from */}
                                        <ExpandableComponent
                                            title={t('broker').toUpperCase()}
                                            subtitle={<span className="main-title"> {selectedBroker?.ent_occupation_xx}</span>}
                                            defaultExpanded={true}
                                        >
                                            <div className="content-details-row client">
                                                <motion.div
                                                    className="entity-details-container"
                                                    initial={{ opacity: 0 }}
                                                    animate={{ opacity: 1, transition: { duration: 1 } }}
                                                    exit={{ opacity: 0, transition: { duration: 1 } }}>
                                                    <div className="entity-details-wrapper">
                                                        <div className="entity-details-left">
                                                            {selectedBroker?.ent_photo_url ?
                                                                <img src={selectedBroker?.ent_photo_url} alt="" className="img" /> : <CiImageOn style={{ width: "60px", height: "60px" }} />}
                                                        </div>
                                                        <div className="entity-details-right">
                                                            <div className="name-row">
                                                                {documentEnabled === "Y" ?
                                                                    <div className="input-item-with-label">
                                                                        <AsyncSelect
                                                                            ref={brokerRef}
                                                                            id="broker_ent"
                                                                            name="broker_ent"
                                                                            menuPortalTarget={document.body}
                                                                            styles={{
                                                                                ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                                                                menuPortal: base => ({
                                                                                    ...base,
                                                                                    zIndex: 9999,
                                                                                })
                                                                            }}
                                                                            width="350px"
                                                                            isClearable
                                                                            value={selectedBroker}
                                                                            onChange={(selectedOption) => setSelectedBroker(selectedOption)}
                                                                            loadOptions={(inputValue, callback) => fetchClientsBySearch(inputValue, callback, [])}
                                                                            isSearchable={true}
                                                                            placeholder={t('broker').toUpperCase()}
                                                                            noOptionsMessage={() => "Type Minimum 3 Letter to Search"}
                                                                        />
                                                                    </div>
                                                                    :
                                                                    <span className="main-title"> {tradeData?.broker_details_xx?.ent_name} </span>}
                                                            </div>
                                                            <div className="email-phone-row">
                                                                <span className="email-phone-details" style={{ cursor: "pointer" }}
                                                                    onClick={() => {
                                                                        try {
                                                                            setEmailData({
                                                                                to: tradeData?.broker_details_xx?.ent_email,
                                                                                cc: '',
                                                                                bcc: '',
                                                                                subject: `RECEIPT NO ${tradeData?.hd_no}`,
                                                                                show_attach: "Y",
                                                                                attached_urls: [],
                                                                                binary_docs: [],
                                                                                doc_no: tradeData?.hd_no,
                                                                                doc_type: "AM Trade",
                                                                                doc_id: tradeDocId,
                                                                                entity_codes: [tradeData?.broker_details_xx?.value],
                                                                                search_string: tradeData?.broker_details_xx?.label?.props?.children[0] + "," + tradeData?.hd_no,
                                                                                carrierName: '',
                                                                                productName: '',
                                                                                clientName: tradeData?.broker_details_xx?.label?.props?.children[0],
                                                                                riskNoteNo: tradeData?.hd_no,
                                                                                daysToRenewal: tradeData?.expiring_in_days,
                                                                                expiryDate: tradeData?.fmt_to_date,
                                                                                insuredName: tradeData?.broker_details_xx?.label?.props?.children[0],
                                                                                outstandingPremium: tradeData?.outstandingPremium,
                                                                                policyCurrency: tradeData?.hd_cur_code,
                                                                                policyNumber: tradeData?.hd_no,
                                                                                policyPremium: tradeData?.fmt_policy_fc_prem,
                                                                                policyPremiumTotal: tradeData?.fmt_total_fc_prem,
                                                                                policySumInsured: tradeData?.fmt_total_fc_si,
                                                                                policyFromDate: tradeData?.fmt_fm_date,
                                                                                policyToDate: tradeData?.fmt_to_date,
                                                                                tpt_category: []
                                                                            });
                                                                            setEmailDialogOpen(true);
                                                                        } catch (error) {
                                                                            console.log(error)
                                                                        }
                                                                    }}>
                                                                    <MdEmail className="icon" /> <h1 className="sub-title">{selectedBroker?.ent_email || "Unspecified"}</h1>
                                                                </span>
                                                                <span className="email-phone-details">
                                                                    <MdPhone className="icon" /> <h1 className="sub-title">{selectedBroker?.ent_phone_no || "Unspecified"}</h1>
                                                                </span>
                                                                <span className="email-phone-details">
                                                                    <MdOutlineNumbers className="icon" /> <h1 className="sub-title">{selectedBroker?.aent_name_xx || ""}</h1>
                                                                </span>
                                                                <span className="email-phone-details"
                                                                    style={{ cursor: "pointer" }}
                                                                    onClick={() => navigate(`/entity/${selectedBroker?.ent_docid}`)}>
                                                                    <TagIcon className="icon" /> <h1 className="sub-title">{selectedBroker?.ent_code}</h1>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </motion.div>
                                            </div>
                                        </ExpandableComponent>
                                        {/* end of transaction  */}
                                        {/* transaction details */}
                                        <ExpandableComponent
                                            title={t('tradeDetails').toUpperCase()}
                                            subtitle={<span className={`status ${tradeData?.hd_status}`}>{`${t('status').toUpperCase()} ${tradeData?.hd_status}`}</span>}
                                            defaultExpanded={true}
                                        >
                                            <div className="content-details-row">
                                                <div className="content-details-left">
                                                    <div className="input-item-with-label">
                                                        <label htmlFor="fund_code" className="form-dropdown-label" style={{ width: "100px" }}>{t('fund').toUpperCase()}</label>
                                                        {documentEnabled === "Y" ?
                                                            <Select
                                                                id="fund_code"
                                                                name="fund_code"
                                                                menuPortalTarget={document.body}
                                                                styles={{
                                                                    ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                                                    menuPortal: base => ({
                                                                        ...base,
                                                                        zIndex: 9999,
                                                                    })
                                                                }}
                                                                width="450px"
                                                                value={selectedFund}
                                                                onChange={(selectedOption) => setSelectedFund(selectedOption)}
                                                                options={funds}
                                                                isSearchable={true}
                                                                isDisabled={documentEnabled === "N"}
                                                                placeholder={t('fund').toUpperCase()}
                                                            /> :
                                                            <input
                                                                id="fund_name"
                                                                name="fund_name"
                                                                type="text"
                                                                className="form-input-item"
                                                                style={{ width: "450px" }}
                                                                value={tradeData?.fund_name_xx}
                                                                disabled={true}
                                                            />}
                                                    </div>
                                                    <div className="input-item-with-label">
                                                        <label htmlFor="security_code" className="form-dropdown-label" style={{ width: "100px" }}>{t('security').toUpperCase()}</label>
                                                        {documentEnabled === "Y" ?
                                                            <Select
                                                                id="security_code"
                                                                name="security_code"
                                                                menuPortalTarget={document.body}
                                                                styles={{
                                                                    ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                                                    menuPortal: base => ({
                                                                        ...base,
                                                                        zIndex: 9999,
                                                                    })
                                                                }}
                                                                width="450px"
                                                                value={securities.find(option => option.security_docid?.toString() === tradeData?.security_docid?.toString()) || null}
                                                                onChange={selectedOption => {
                                                                    try {
                                                                        // console.log(`selectedOption ... ${JSON.stringify(selectedOption, null, 2)}`);
                                                                        handleSetTradeData("security_name", selectedOption?.label);
                                                                        handleSetTradeData("security_docid", selectedOption?.security_docid);
                                                                        handleSetTradeData("security_type", selectedOption?.security_type);
                                                                    } catch (error) {
                                                                        console.log(error);
                                                                    }
                                                                }}
                                                                options={securities}
                                                                isSearchable={true}
                                                                isDisabled={documentEnabled === "N"}
                                                                placeholder={t('security').toUpperCase()}
                                                            /> :
                                                            <input
                                                                id="security_name"
                                                                name="security_name"
                                                                type="text"
                                                                className="form-input-item"
                                                                style={{ width: "450px" }}
                                                                value={tradeData?.security_name}
                                                                disabled={true}
                                                            />}
                                                    </div>
                                                    <div style={{
                                                        display: "flex",
                                                        flexDirection: "row",
                                                        alignItems: "start",
                                                        justifyContent: "space-between",
                                                        width: "100%",
                                                    }}>
                                                        <div className="input-item-with-label">
                                                            <label
                                                                htmlFor="trade_type"
                                                                className="form-dropdown-label" style={{ width: "100px" }}
                                                            >
                                                                {t('trade').toUpperCase()}
                                                            </label>
                                                            {documentEnabled === "Y" ?
                                                                <Select
                                                                    ref={tradeTypeRef}
                                                                    id="trade_type"
                                                                    name="trade_type"
                                                                    menuPortalTarget={document.body}
                                                                    styles={{
                                                                        ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                                                        menuPortal: base => ({
                                                                            ...base,
                                                                            zIndex: 9999,
                                                                        })
                                                                    }}
                                                                    width="170px"
                                                                    value={tradeTypes.find(option => option.value === tradeData?.trade_type) || null}
                                                                    onChange={selectedOption => handleSetTradeData("trade_type", selectedOption?.value)}
                                                                    options={tradeTypes}
                                                                    isSearchable={true}
                                                                    placeholder={t('trade').toUpperCase()}
                                                                    isDisabled={documentEnabled === "N"}
                                                                /> :
                                                                <input
                                                                    id="trade_type_xx"
                                                                    name="trade_type_xx"
                                                                    type="text"
                                                                    className="form-input-item"
                                                                    style={{ width: "170px" }}
                                                                    value={tradeData?.trade_type}
                                                                    disabled={true}
                                                                />}
                                                        </div>
                                                        <div className="input-item-with-label">
                                                            <label
                                                                htmlFor="security_type"
                                                                className="form-dropdown-label"
                                                            >
                                                                {t('type').toUpperCase()}
                                                            </label>
                                                            <input
                                                                id="security_type"
                                                                name="security_type"
                                                                type="text"
                                                                placeholder={t('class').toUpperCase()}
                                                                className="form-input-item"
                                                                style={{ width: "170px" }}
                                                                value={tradeData?.security_type}
                                                                disabled={true}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            flexDirection: "row",
                                                            alignItems: "center",
                                                            width: "100%",
                                                        }}
                                                    >
                                                        <div className="input-item-with-label">
                                                            <label
                                                                htmlFor="hd_biz_unit"
                                                                className="form-dropdown-label"
                                                                style={{ width: "100px" }}
                                                            >
                                                                {t('bizUnit').toUpperCase()}
                                                            </label>
                                                            {documentEnabled === "Y" ?
                                                                <Select
                                                                    id="hd_biz_unit"
                                                                    name="hd_biz_unit"
                                                                    menuPortalTarget={document.body}
                                                                    styles={{
                                                                        ...(currentTheme === "dark"
                                                                            ? customSelectStyles_dark
                                                                            : customSelectStyles_light),
                                                                        menuPortal: (base) => ({
                                                                            ...base,
                                                                            zIndex: 9999,
                                                                        }),
                                                                    }}
                                                                    width="170px"
                                                                    value={branches.find(option => option.value === tradeData?.hd_biz_unit) || null}
                                                                    onChange={selectedOption => handleSetTradeData("hd_biz_unit", selectedOption?.value)}
                                                                    options={branches}
                                                                    isSearchable={true}
                                                                    isDisabled={documentEnabled === "N"}
                                                                    placeholder={t('bizUnit').toUpperCase()}
                                                                /> :
                                                                <input
                                                                    id="bizunit_name_xx"
                                                                    name="bizunit_name_xx"
                                                                    type="text"
                                                                    className="form-input-item"
                                                                    style={{ width: "170px" }}
                                                                    value={tradeData?.bizunit_name_xx}
                                                                    disabled={true}
                                                                />}
                                                        </div>
                                                        <div className="input-item-with-label" style={{ marginLeft: "auto" }}>
                                                            <label
                                                                htmlFor="hd_cur_code"
                                                                className="form-dropdown-label"
                                                                style={{ width: "80px" }}
                                                            >
                                                                {t('currency').toUpperCase()}
                                                            </label>
                                                            {documentEnabled === "Y" ?
                                                                <Select
                                                                    id="hd_cur_code"
                                                                    name="hd_cur_code"
                                                                    menuPortalTarget={document.body}
                                                                    styles={{
                                                                        ...(currentTheme === "dark"
                                                                            ? customSelectStyles_dark
                                                                            : customSelectStyles_light),
                                                                        menuPortal: (base) => ({
                                                                            ...base,
                                                                            zIndex: 9999,
                                                                        }),
                                                                    }}
                                                                    width="170px"
                                                                    value={currencies.find(option => option.value === tradeData?.hd_cur_code) || null}
                                                                    onChange={async (selectedOption) => {
                                                                        try {
                                                                            if (selectedOption.value !== currentUser?.currency_code_xx) {
                                                                                handleSetTradeData("hd_cur_code", selectedOption?.value);
                                                                                const formattedDate = moment(tradeData?.hd_gl_date).format("YYYY-MM-DD");
                                                                                const res = await newRequest.post("/glCurrencyRate/find", {
                                                                                    rate_org_code: currentUser.usr_org_code,
                                                                                    rate_cur_code_fm: selectedOption.value,
                                                                                    rate_cur_code_to: currentUser?.currency_code_xx,
                                                                                    rate_date: formattedDate,
                                                                                });

                                                                                if (res.data) {
                                                                                    handleSetTradeData("hd_cur_rate", res.data.rate);
                                                                                    const refreshedAmounts = recalculateAmounts();
                                                                                    handleSetTradeData("hd_fc_amount", formatAmountsToDecimals(refreshedAmounts?.fcAmount || 0, 2));
                                                                                    handleSetTradeData("hd_lc_mount", formatAmountsToDecimals(refreshedAmounts?.lcAmount || 0, 2));
                                                                                } else {
                                                                                    handleSetTradeData("hd_cur_code", currentUser?.currency_code_xx);
                                                                                    handleSetTradeData("hd_cur_rate", 1);
                                                                                    setNotifyDialogTitle("Note!");
                                                                                    setNotifyDialogText(
                                                                                        `Conversion Rate from <strong>${selectedOption.value} to ${currentUser?.currency_code_xx} for date ${moment(tradeData?.hd_gl_date).format(
                                                                                            "DD-MMM-YYYY"
                                                                                        )}</strong> NOT found. Currency will reset to <strong>${currentUser?.currency_code_xx}</strong>`
                                                                                    );
                                                                                    setIsNotifyDialogOpen(true);
                                                                                }
                                                                            } else {
                                                                                handleSetTradeData("hd_cur_code", currentUser?.currency_code_xx);
                                                                                handleSetTradeData("hd_cur_rate", 1);
                                                                            }
                                                                        } catch (error) {
                                                                            console.log(error);
                                                                        }
                                                                    }}
                                                                    options={currencies}
                                                                    isSearchable={true}
                                                                    isDisabled={documentEnabled === "N"}
                                                                    placeholder={t('currency').toUpperCase()}
                                                                /> :
                                                                <input
                                                                    id="hd_cur_code_xx"
                                                                    name="hd_cur_code_xx"
                                                                    type="text"
                                                                    className="form-input-item"
                                                                    style={{ width: "170px" }}
                                                                    value={tradeData?.hd_cur_code}
                                                                    disabled={true}
                                                                />}
                                                        </div>
                                                    </div>
                                                    <div style={{
                                                        display: "flex",
                                                        flexDirection: "row",
                                                        alignItems: "start",
                                                        justifyContent: "space-between",
                                                        width: "100%",
                                                    }}>
                                                        <div className="input-item-with-label">
                                                            <label
                                                                htmlFor="hd_priority"
                                                                className="form-dropdown-label" style={{ width: "100px" }}
                                                            >
                                                                {t('priority').toUpperCase()}
                                                            </label>
                                                            {documentEnabled === "Y" ?
                                                                <Select
                                                                    id="hd_priority"
                                                                    name="hd_priority"
                                                                    menuPortalTarget={document.body}
                                                                    styles={{
                                                                        ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                                                        menuPortal: base => ({
                                                                            ...base,
                                                                            zIndex: 9999,
                                                                        })
                                                                    }}
                                                                    width="170px"
                                                                    value={priorityLevels.find(option => option.value === tradeData?.hd_priority) || null}
                                                                    onChange={selectedOption => handleSetTradeData("hd_priority", selectedOption?.value)}
                                                                    options={priorityLevels}
                                                                    isSearchable={true}
                                                                    placeholder={t('priority').toUpperCase()}
                                                                    isDisabled={documentEnabled === "N"}
                                                                /> :
                                                                <input
                                                                    id="hd_priority_xx"
                                                                    name="hd_priority_xx"
                                                                    type="text"
                                                                    className="form-input-item"
                                                                    style={{ width: "170px" }}
                                                                    value={tradeData?.hd_priority}
                                                                    disabled={true}
                                                                />}
                                                        </div>
                                                        <div className="input-item-with-label">
                                                            <label
                                                                htmlFor="hd_gl_date"
                                                                className="form-dropdown-label"
                                                            >
                                                                {t('glDate').toUpperCase()}
                                                            </label>
                                                            <input
                                                                id="hd_gl_date"
                                                                name="hd_gl_date"
                                                                type="date"
                                                                placeholder={t('glDate').toUpperCase()}
                                                                className="form-input-item"
                                                                style={{ width: "170px" }}
                                                                value={tradeData?.hd_gl_date}
                                                                onChange={(e) => {
                                                                    try {
                                                                        const formattedDate = moment(e.target.value).format("YYYY-MM-DD");
                                                                        handleSetTradeData("hd_gl_date", formattedDate);
                                                                    } catch (error) {
                                                                        console.log(error);
                                                                    }
                                                                }}
                                                                disabled={documentEnabled === "N"}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="content-details-right">
                                                    <div className="input-item-with-label">
                                                        <label htmlFor="hd_no" className="form-dropdown-label">
                                                            {t('no').toUpperCase()}
                                                        </label>
                                                        <input
                                                            id="hd_no"
                                                            name="hd_no"
                                                            type="text"
                                                            placeholder={t('no').toUpperCase()}
                                                            value={tradeData?.hd_no}
                                                            className="form-input-item"
                                                            style={{ width: "200px" }}
                                                            onChange={selectedOption => handleSetTradeData("hd_no", selectedOption?.value)}
                                                            disabled={tradeData?.hd_no}
                                                        />
                                                    </div>
                                                    <div className="input-item-with-label">
                                                        <label
                                                            htmlFor="hd_ref_no"
                                                            className="form-dropdown-label"
                                                            style={{ width: "100px" }}
                                                        >
                                                            {t('ref').toUpperCase()}
                                                        </label>
                                                        <input
                                                            id="hd_ref_no"
                                                            name="hd_ref_no"
                                                            type="text"
                                                            placeholder={t('ref').toUpperCase()}
                                                            className="form-input-item"
                                                            style={{ width: "200px" }}
                                                            value={tradeData?.hd_ref_no}
                                                            onChange={(e) => handleSetTradeData("hd_ref_no", e.target.value)}
                                                            disabled={documentEnabled === "N"}
                                                        />
                                                    </div>
                                                    <div className="input-item-with-label">
                                                        <label
                                                            htmlFor="settlement_status"
                                                            className="form-dropdown-label"
                                                            style={{ width: "100px" }}
                                                        >
                                                            {t('settlement').toUpperCase()}
                                                        </label>
                                                        {documentEnabled === "Y" ?
                                                            <Select
                                                                id="settlement_status"
                                                                name="settlement_status"
                                                                menuPortalTarget={document.body}
                                                                styles={{
                                                                    ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                                                    menuPortal: base => ({
                                                                        ...base,
                                                                        zIndex: 9999,
                                                                    })
                                                                }}
                                                                width="200px"
                                                                value={settlementStatuses.find(option => option.value === tradeData?.settlement_status) || null}
                                                                onChange={selectedOption => handleSetTradeData("settlement_status", selectedOption?.value)}
                                                                options={settlementStatuses}
                                                                isSearchable={true}
                                                                placeholder={t('trade').toUpperCase()}
                                                                isDisabled={documentEnabled === "N"}
                                                            /> :
                                                            <input
                                                                id="settlement_status_xx"
                                                                name="settlement_status_xx"
                                                                type="text"
                                                                className="form-input-item"
                                                                style={{ width: "200px" }}
                                                                value={tradeData?.settlement_status}
                                                                disabled={true}
                                                            />}
                                                    </div>
                                                    <div className="input-item-with-label">
                                                        <label
                                                            htmlFor="settlement_date"
                                                            className="form-dropdown-label"
                                                            style={{ width: "max-content" }}
                                                        >
                                                            {t('settDt').toUpperCase()}
                                                        </label>
                                                        <input
                                                            id="settlement_date"
                                                            name="settlement_date"
                                                            type="date"
                                                            placeholder={t('settlement').toUpperCase()}
                                                            className="form-input-item"
                                                            style={{ width: "200px" }}
                                                            value={tradeData?.settlement_date}
                                                            onChange={(e) => {
                                                                try {
                                                                    const formattedDate = moment(e.target.value).format("YYYY-MM-DD");
                                                                    handleSetTradeData("settlement_date", formattedDate);
                                                                } catch (error) {
                                                                    console.log(error);
                                                                }
                                                            }}
                                                            disabled={documentEnabled === "N"}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="input-item-with-label" style={{ width: "100%", marginBottom: "5px" }}>
                                                <label
                                                    htmlFor="hd_ref_no"
                                                    className="form-dropdown-label"
                                                    style={{ width: "115px", alignSelf: "flex-start" }}
                                                >
                                                    {t('narration').toUpperCase()}
                                                </label>
                                                <textarea
                                                    id="hd_narration"
                                                    name="hd_narration"
                                                    type="text"
                                                    rows={2}
                                                    placeholder={t('narration').toUpperCase()}
                                                    value={tradeData?.hd_narration}
                                                    className="form-input-item"
                                                    style={{ width: "100%" }}
                                                    onChange={selectedOption => handleSetTradeData("hd_narration", selectedOption?.value)}
                                                    disabled={documentEnabled === "N"}
                                                />
                                            </div>
                                            <hr className="separator-h" />
                                            <span className="sub-title" style={{ margin: "10px 0px 10px 30px" }} >{t('instruction').toUpperCase()}</span>
                                            {/* VIEW FOR EQUITIES */}
                                            {tradeData?.security_type === "Equity" &&
                                                <>
                                                    {/* SHOWN AT ISSUING INSTRUCTIONS */}
                                                    <div className="equity-wrapper" style={{ marginBottom: "10px" }}>
                                                        <div className="equity-details">
                                                            <div className="equity-cols">
                                                                <div className="input-item-with-label">
                                                                    <label
                                                                        htmlFor="gross_equity"
                                                                        className="form-dropdown-label"
                                                                        style={{ width: "100px" }}
                                                                    >
                                                                        {t('value').toUpperCase()}
                                                                    </label>
                                                                    <input
                                                                        id="hd_fc_amount"
                                                                        name="hd_fc_amount"
                                                                        type="text"
                                                                        placeholder="0.00"
                                                                        className="form-input-item"
                                                                        style={{ width: "170px", textAlign: "end" }}
                                                                        value={tradeData?.hd_fc_amount}
                                                                        onChange={(e) => handleSetTradeData("hd_fc_amount", e.target.value)}
                                                                        onBlur={(e) => {
                                                                            try {
                                                                                if (e.target.value) {
                                                                                    const strippedValue = parseFloat(formatStringToNumberV2(e.target.value));
                                                                                    if (isNaN(strippedValue)) {
                                                                                        setNotifyDialogTitle("Error!");
                                                                                        setNotifyDialogText(`Invalid Number <strong>${strippedValue}</strong>`);
                                                                                        setIsNotifyDialogOpen(true);
                                                                                        return;
                                                                                    }
                                                                                    handleSetTradeData("hd_fc_amount", formatAmountsToDecimals(strippedValue || 0, 2));
                                                                                    const rate = parseFloat(tradeData?.hd_cur_rate || 1);
                                                                                    const lcAmount = parseFloat((strippedValue * rate).toFixed(4));
                                                                                    handleSetTradeData("hd_lc_amount", formatAmountsToDecimals(lcAmount || 0, 2));
                                                                                }
                                                                            } catch (error) {
                                                                                console.log(error)
                                                                            }
                                                                        }}
                                                                        disabled={documentEnabled === "N"}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="equity-cols">
                                                                <div className="input-item-with-label">
                                                                    <label
                                                                        htmlFor="equity_price"
                                                                        className="form-dropdown-label"
                                                                        style={{ width: "80px" }}
                                                                    >
                                                                        {t('price').toUpperCase()}
                                                                    </label>
                                                                    <input
                                                                        id="equity_price"
                                                                        name="equity_price"
                                                                        type="text"
                                                                        placeholder="0.00"
                                                                        className="form-input-item"
                                                                        style={{ width: "170px", textAlign: "end" }}
                                                                        value={tradeData?.equity_price}
                                                                        onChange={(e) => handleSetTradeData("equity_price", e.target.value)}
                                                                        onBlur={(e) => {
                                                                            try {
                                                                                if (e.target.value) {
                                                                                    const strippedValue = parseFloat(formatStringToNumberV2(e.target.value));
                                                                                    if (isNaN(strippedValue)) {
                                                                                        setNotifyDialogTitle("Error!");
                                                                                        setNotifyDialogText(`Invalid Number <strong>${strippedValue}</strong>`);
                                                                                        setIsNotifyDialogOpen(true);
                                                                                        return;
                                                                                    }
                                                                                    handleSetTradeData("equity_price", formatAmountsToDecimals(strippedValue || 0, 2));
                                                                                }
                                                                            } catch (error) {
                                                                                console.log(error)
                                                                            }
                                                                        }}
                                                                        disabled={documentEnabled === "N"}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="equity-cols">
                                                                <div className="input-item-with-label">
                                                                    <label
                                                                        htmlFor="equity_quantity"
                                                                        className="form-dropdown-label"
                                                                        style={{ width: "100px" }}
                                                                    >
                                                                        {t('units').toUpperCase()}
                                                                    </label>
                                                                    <input
                                                                        id="equity_quantity"
                                                                        name="equity_quantity"
                                                                        type="text"
                                                                        placeholder="0.00"
                                                                        className="form-input-item"
                                                                        style={{ width: "200px", textAlign: "end" }}
                                                                        value={tradeData?.equity_quantity}
                                                                        onChange={(e) => handleSetTradeData("equity_quantity", e.target.value)}
                                                                        disabled={true}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {/* SHOWN AFTER EXECUTION */}
                                                    {tradeData?.settlement_status === "Settled" &&
                                                        <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
                                                            <hr className="separator-h" />
                                                            <span className="status Critical sub-title" style={{ marginLeft: "30px" }} >{`${t('executed').toUpperCase()} ${tradeData?.executed_prompt_xx}`}</span>
                                                            <div className="equity-wrapper" style={{ marginTop: "10px" }}>
                                                                <div className="equity-details">
                                                                    <div className="bond-cols">
                                                                        <div className="input-item-with-label">
                                                                            <label
                                                                                htmlFor="execution_fc_amount"
                                                                                className="form-dropdown-label"
                                                                                style={{ width: "100px" }}
                                                                            >
                                                                                {t('value').toUpperCase()}
                                                                            </label>
                                                                            <input
                                                                                id="execution_fc_amount"
                                                                                name="execution_fc_amount"
                                                                                type="text"
                                                                                placeholder="0.00"
                                                                                className="form-input-item"
                                                                                style={{ width: "170px", textAlign: "end" }}
                                                                                value={tradeData?.execution_fc_amount}
                                                                                onChange={(e) => handleSetTradeData("execution_fc_amount", e.target.value)}
                                                                                disabled={true}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className="equity-cols">
                                                                        <div className="input-item-with-label">
                                                                            <label
                                                                                htmlFor="execution_price"
                                                                                className="form-dropdown-label"
                                                                                style={{ width: "100px" }}
                                                                            >
                                                                                {t('price').toUpperCase()}
                                                                            </label>
                                                                            <input
                                                                                id="execution_price"
                                                                                name="execution_price"
                                                                                type="text"
                                                                                placeholder="0.00"
                                                                                className="form-input-item"
                                                                                style={{ width: "170px", textAlign: "end" }}
                                                                                value={tradeData?.execution_price}
                                                                                disabled={documentEnabled === "N"}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className="bond-cols">
                                                                        <div className="input-item-with-label">
                                                                            <label
                                                                                htmlFor="executed_quantity"
                                                                                className="form-dropdown-label"
                                                                                style={{ width: "max-content" }}
                                                                            >
                                                                                {t('units').toUpperCase()}
                                                                            </label>
                                                                            <input
                                                                                id="executed_quantity"
                                                                                name="executed_quantity"
                                                                                type="text"
                                                                                placeholder="0.00"
                                                                                className="form-input-item"
                                                                                style={{ width: "200px", textAlign: "end" }}
                                                                                value={tradeData?.executed_quantity}
                                                                                disabled={documentEnabled === "N"}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    }
                                                </>
                                            }
                                            {/* VIEW FOR BOND */}
                                            {tradeData?.security_type === "Bond" &&
                                                <div className="bond-wrapper">
                                                    <div className="bond-details">
                                                        <div className="bond-cols">
                                                            <div className="input-item-with-label">
                                                                <label
                                                                    htmlFor="market_type"
                                                                    className="form-dropdown-label" style={{ width: "100px" }}
                                                                >
                                                                    {t('market').toUpperCase()}
                                                                </label>
                                                                {documentEnabled === "Y" ?
                                                                    <Select
                                                                        id="market_type"
                                                                        name="market_type"
                                                                        menuPortalTarget={document.body}
                                                                        styles={{
                                                                            ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                                                            menuPortal: base => ({
                                                                                ...base,
                                                                                zIndex: 9999,
                                                                            })
                                                                        }}
                                                                        width="170px"
                                                                        value={marketTypes.find(option => option.value === tradeData?.market_type) || null}
                                                                        onChange={selectedOption => handleSetTradeData("market_type", selectedOption?.value)}
                                                                        options={marketTypes}
                                                                        isSearchable={true}
                                                                        placeholder={t('priority').toUpperCase()}
                                                                        isDisabled={documentEnabled === "N"}
                                                                    /> :
                                                                    <input
                                                                        id="market_type_xx"
                                                                        name="market_type_xx"
                                                                        type="text"
                                                                        className="form-input-item"
                                                                        style={{ width: "170px" }}
                                                                        value={tradeData?.market_type}
                                                                        disabled={true}
                                                                    />}
                                                            </div>
                                                            <div className="input-item-with-label">
                                                                <label
                                                                    htmlFor="face_value_fc"
                                                                    className="form-dropdown-label"
                                                                    style={{ width: "100px" }}
                                                                >
                                                                    {t('faceValue').toUpperCase()}
                                                                </label>
                                                                <input
                                                                    id="face_value_fc"
                                                                    name="face_value_fc"
                                                                    type="text"
                                                                    placeholder="0.00"
                                                                    className="form-input-item"
                                                                    style={{ width: "170px", textAlign: "end" }}
                                                                    value={tradeData?.face_value_fc}
                                                                    onChange={(e) => handleSetTradeData("face_value_fc", e.target.value)}
                                                                    onBlur={(e) => {
                                                                        try {
                                                                            if (e.target.value) {
                                                                                const strippedValue = parseFloat(formatStringToNumberV2(e.target.value));
                                                                                if (isNaN(strippedValue)) {
                                                                                    setNotifyDialogTitle("Error!");
                                                                                    setNotifyDialogText(`Invalid Number <strong>${strippedValue}</strong>`);
                                                                                    setIsNotifyDialogOpen(true);
                                                                                    return;
                                                                                }
                                                                                handleSetTradeData("face_value_fc", formatAmountsToDecimals(strippedValue || 0, 2));
                                                                                handleSetTradeData("clean_price_fc", formatAmountsToDecimals(strippedValue || 0, 2));
                                                                                const rate = parseFloat(tradeData?.hd_cur_rate || 1);
                                                                                const lcAmount = parseFloat((strippedValue * rate).toFixed(4));
                                                                                handleSetTradeData("face_value_lc", formatAmountsToDecimals(lcAmount || 0, 2));
                                                                                handleSetTradeData("clean_price_lc", formatAmountsToDecimals(lcAmount || 0, 2));
                                                                            }
                                                                        } catch (error) {
                                                                            console.log(error)
                                                                        }
                                                                    }}
                                                                    disabled={documentEnabled === "N"}
                                                                />
                                                            </div>
                                                            <div className="input-item-with-label">
                                                                <label
                                                                    htmlFor="coupon_rate"
                                                                    className="form-dropdown-label"
                                                                    style={{ width: "100px" }}
                                                                >
                                                                    {t('coupon').toUpperCase()}
                                                                </label>
                                                                <input
                                                                    id="coupon_rate"
                                                                    name="coupon_rate"
                                                                    type="text"
                                                                    placeholder="0.00"
                                                                    className="form-input-item"
                                                                    style={{ width: "170px", textAlign: "end" }}
                                                                    value={tradeData?.coupon_rate}
                                                                    onChange={(e) => handleSetTradeData("coupon_rate", e.target.value)}
                                                                    onBlur={(e) => {
                                                                        try {
                                                                            if (e.target.value) {
                                                                                const strippedValue = parseFloat(formatStringToNumberV2(e.target.value));
                                                                                if (isNaN(strippedValue)) {
                                                                                    setNotifyDialogTitle("Error!");
                                                                                    setNotifyDialogText(`Invalid Number <strong>${strippedValue}</strong>`);
                                                                                    setIsNotifyDialogOpen(true);
                                                                                    return;
                                                                                }
                                                                                handleSetTradeData("coupon_rate", formatAmountsToDecimals(strippedValue || 0, 6));
                                                                                const refreshedAmounts = recalculateAmounts();
                                                                                console.log(`... refreshedAmounts ${JSON.stringify(refreshedAmounts, null, 2)}`);
                                                                                handleSetTradeData("accrued_interest", formatAmountsToDecimals(refreshedAmounts?.accruedInterest || 0, 2));
                                                                            }
                                                                        } catch (error) {
                                                                            console.log(error)
                                                                        }
                                                                    }}
                                                                    disabled={documentEnabled === "N"}
                                                                />
                                                            </div>
                                                            {tradeData?.market_type === "Secondary" &&
                                                                <div className="input-item-with-label">
                                                                    <label
                                                                        htmlFor="day_count_convention"
                                                                        className="form-dropdown-label"
                                                                        style={{ width: "100px" }}
                                                                    >
                                                                        {t('conv').toUpperCase()}
                                                                    </label>
                                                                    {documentEnabled === "Y" ?
                                                                        <Select
                                                                            id="convention"
                                                                            name="convention"
                                                                            menuPortalTarget={document.body}
                                                                            styles={{
                                                                                ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                                                                menuPortal: base => ({
                                                                                    ...base,
                                                                                    zIndex: 9999,
                                                                                })
                                                                            }}
                                                                            width="170px"
                                                                            value={conventions.find(option => option.value === tradeData?.day_count_convention) || null}
                                                                            onChange={selectedOption => handleSetTradeData("day_count_convention", selectedOption?.value)}
                                                                            options={conventions}
                                                                            isSearchable={true}
                                                                            placeholder={t('convention').toUpperCase()}
                                                                            isDisabled={documentEnabled === "N" || tradeData?.market_type === "Primary"}
                                                                        /> :
                                                                        <input
                                                                            id="convention_xx"
                                                                            name="convention_xx"
                                                                            type="text"
                                                                            className="form-input-item"
                                                                            style={{ width: "170px" }}
                                                                            value={tradeData?.day_count_convention}
                                                                            disabled={true}
                                                                        />}
                                                                </div>}
                                                            {tradeData?.market_type === "Secondary" &&
                                                                <div className="input-item-with-label">
                                                                    <label
                                                                        htmlFor="accrued_interest"
                                                                        className="form-dropdown-label"
                                                                        style={{ width: "max-content" }}
                                                                    >
                                                                        {t('accruedInt').toUpperCase()}
                                                                    </label>
                                                                    <input
                                                                        id="accrued_interest"
                                                                        name="accrued_interest"
                                                                        type="text"
                                                                        placeholder="0.00"
                                                                        className="form-input-item"
                                                                        style={{ width: "170px", textAlign: "end" }}
                                                                        value={tradeData?.accrued_interest}
                                                                        onChange={(e) => handleSetTradeData("accrued_interest", e.target.value)}
                                                                        disabled={true}
                                                                    />
                                                                </div>}
                                                        </div>
                                                        <div className="bond-cols">
                                                            <div className="input-item-with-label">
                                                                <label
                                                                    htmlFor="clean_price_fc"
                                                                    className="form-dropdown-label"
                                                                    style={{ width: "80px" }}
                                                                >
                                                                    {t('cleanPrice').toUpperCase()}
                                                                </label>
                                                                <input
                                                                    id="clean_price_fc"
                                                                    name="clean_price_fc"
                                                                    type="text"
                                                                    placeholder="0.00"
                                                                    className="form-input-item"
                                                                    style={{ width: "170px", textAlign: "end" }}
                                                                    value={tradeData?.clean_price_fc}
                                                                    onChange={(e) => handleSetTradeData("clean_price_fc", e.target.value)}
                                                                    onBlur={(e) => {
                                                                        try {
                                                                            if (e.target.value) {
                                                                                const strippedValue = parseFloat(formatStringToNumberV2(e.target.value));
                                                                                if (isNaN(strippedValue)) {
                                                                                    setNotifyDialogTitle("Error!");
                                                                                    setNotifyDialogText(`Invalid Number <strong>${strippedValue}</strong>`);
                                                                                    setIsNotifyDialogOpen(true);
                                                                                    return;
                                                                                }
                                                                                handleSetTradeData("clean_price_fc", formatAmountsToDecimals(strippedValue || 0, 2));
                                                                                const rate = parseFloat(tradeData?.hd_cur_rate || 1);
                                                                                const lcAmount = parseFloat((strippedValue * rate).toFixed(4));
                                                                                handleSetTradeData("clean_price_lc", formatAmountsToDecimals(lcAmount || 0, 2));
                                                                            }
                                                                        } catch (error) {
                                                                            console.log(error)
                                                                        }
                                                                    }}
                                                                    disabled={documentEnabled === "N"}
                                                                />
                                                            </div>
                                                            <div className="input-item-with-label">
                                                                <label
                                                                    htmlFor="coupon_start_date"
                                                                    className="form-dropdown-label"
                                                                    style={{ width: "80px" }}
                                                                >
                                                                    {t('from').toUpperCase()}
                                                                </label>
                                                                <input
                                                                    id="coupon_start_date"
                                                                    name="coupon_start_date"
                                                                    type="date"
                                                                    placeholder={t('settlement').toUpperCase()}
                                                                    className="form-input-item"
                                                                    style={{ width: "170px" }}
                                                                    value={tradeData?.coupon_start_date}
                                                                    onChange={(e) => {
                                                                        try {
                                                                            const formattedDate = moment(e.target.value).format("YYYY-MM-DD");
                                                                            handleSetTradeData("coupon_start_date", formattedDate);
                                                                        } catch (error) {
                                                                            console.log(error);
                                                                        }
                                                                    }}
                                                                    disabled={documentEnabled === "N"}
                                                                />
                                                            </div>

                                                            <div className="input-item-with-label">
                                                                <label
                                                                    htmlFor="coupon_maturity_date"
                                                                    className="form-dropdown-label"
                                                                    style={{ width: "80px" }}
                                                                >
                                                                    {t('to').toUpperCase()}
                                                                </label>
                                                                <input
                                                                    id="coupon_maturity_date"
                                                                    name="coupon_maturity_date"
                                                                    type="date"
                                                                    placeholder={t('settlement').toUpperCase()}
                                                                    className="form-input-item"
                                                                    style={{ width: "170px" }}
                                                                    value={tradeData?.coupon_maturity_date}
                                                                    onChange={(e) => {
                                                                        try {
                                                                            const formattedDate = moment(e.target.value).format("YYYY-MM-DD");
                                                                            handleSetTradeData("coupon_maturity_date", formattedDate);
                                                                        } catch (error) {
                                                                            console.log(error);
                                                                        }
                                                                    }}
                                                                    disabled={documentEnabled === "N"}
                                                                />
                                                            </div>
                                                            {tradeData?.market_type === "Secondary" &&
                                                                <div className="input-item-with-label">
                                                                    <label
                                                                        htmlFor="last_coupon_date"
                                                                        className="form-dropdown-label"
                                                                        style={{ width: "80px" }}
                                                                    >
                                                                        {t('lastCoupon').toUpperCase()}
                                                                    </label>
                                                                    <input
                                                                        id="last_coupon_date"
                                                                        name="last_coupon_date"
                                                                        type="date"
                                                                        placeholder={t('lastCoupon').toUpperCase()}
                                                                        className="form-input-item"
                                                                        style={{ width: "170px" }}
                                                                        value={tradeData?.last_coupon_date}
                                                                        onChange={(e) => {
                                                                            try {
                                                                                const formattedDate = moment(e.target.value).format("YYYY-MM-DD");
                                                                                handleSetTradeData("last_coupon_date", formattedDate);
                                                                            } catch (error) {
                                                                                console.log(error);
                                                                            }
                                                                        }}
                                                                        disabled={documentEnabled === "N" || tradeData?.market_type === "Primary"}
                                                                    />
                                                                </div>}
                                                        </div>
                                                        <div className="bond-cols">
                                                            <div className="input-item-with-label">
                                                                <label
                                                                    htmlFor="coupon_frequency"
                                                                    className="form-dropdown-label"
                                                                    style={{ width: "100px" }}
                                                                >
                                                                    {t('freq').toUpperCase()}
                                                                </label>
                                                                {documentEnabled === "Y" ?
                                                                    <Select
                                                                        id="coupon_frequency"
                                                                        name="coupon_frequency"
                                                                        menuPortalTarget={document.body}
                                                                        styles={{
                                                                            ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                                                            menuPortal: base => ({
                                                                                ...base,
                                                                                zIndex: 9999,
                                                                            })
                                                                        }}
                                                                        width="200px"
                                                                        value={couponFrequencies.find(option => option.value === tradeData?.coupon_frequency) || null}
                                                                        onChange={selectedOption => handleSetTradeData("coupon_frequency", selectedOption?.value)}
                                                                        options={couponFrequencies}
                                                                        isSearchable={true}
                                                                        placeholder={t('freq').toUpperCase()}
                                                                        isDisabled={documentEnabled === "N"}
                                                                    /> :
                                                                    <input
                                                                        id="freq_xx"
                                                                        name="freq_xx"
                                                                        type="text"
                                                                        className="form-input-item"
                                                                        style={{ width: "200px" }}
                                                                        value={tradeData?.coupon_frequency}
                                                                        disabled={true}
                                                                    />}
                                                            </div>
                                                            <div className="input-item-with-label">
                                                                <label
                                                                    htmlFor="gross_bond_fc"
                                                                    className="form-dropdown-label"
                                                                    style={{ width: "100px" }}
                                                                >
                                                                    {t('invested').toUpperCase()}
                                                                </label>
                                                                <input
                                                                    id="gross_bond_fc"
                                                                    name="gross_bond_fc"
                                                                    type="text"
                                                                    placeholder="0.00"
                                                                    className="form-input-item"
                                                                    style={{ width: "200px", textAlign: "end" }}
                                                                    value={tradeData?.hd_fc_amount}
                                                                    onChange={(e) => handleSetTradeData("hd_fc_amount", e.target.value)}
                                                                    onBlur={(e) => {
                                                                        try {
                                                                            if (e.target.value) {
                                                                                const strippedValue = parseFloat(formatStringToNumberV2(e.target.value));
                                                                                if (isNaN(strippedValue)) {
                                                                                    setNotifyDialogTitle("Error!");
                                                                                    setNotifyDialogText(`Invalid Number <strong>${strippedValue}</strong>`);
                                                                                    setIsNotifyDialogOpen(true);
                                                                                    return;
                                                                                }
                                                                                handleSetTradeData("hd_fc_amount", formatAmountsToDecimals(strippedValue || 0, 2));
                                                                                const lcAmount = parseFloat((strippedValue * (tradeData?.hd_cur_rate || 1)).toFixed(4));
                                                                                handleSetTradeData("hd_lc_amount", formatAmountsToDecimals(lcAmount || 0, 2));
                                                                            }
                                                                        } catch (error) {
                                                                            console.log(error)
                                                                        }
                                                                    }}
                                                                    disabled={documentEnabled === "N"}
                                                                />
                                                            </div>
                                                            <div className="input-item-with-label">
                                                                <label
                                                                    htmlFor="units_bought"
                                                                    className="form-dropdown-label"
                                                                    style={{ width: "100px" }}
                                                                >
                                                                    {t('units').toUpperCase()}
                                                                </label>
                                                                <input
                                                                    id="units_bought"
                                                                    name="units_bought"
                                                                    type="text"
                                                                    placeholder="0.00"
                                                                    className="form-input-item"
                                                                    style={{ width: "200px", textAlign: "end" }}
                                                                    value={tradeData?.bond_quantity}
                                                                    onChange={(e) => handleSetTradeData("bond_quantity", e.target.value)}
                                                                    disabled={true}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {/* SHOWN AFTER EXECUTION */}
                                                    {tradeData?.settlement_status === "Settled" &&
                                                        <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
                                                            <hr className="separator-h" />
                                                            <span className="status Critical sub-title" style={{ marginLeft: "30px" }} >{`${t('executed').toUpperCase()} ${tradeData?.executed_prompt_xx}`}</span>
                                                            <div className="equity-wrapper" style={{ marginTop: "10px" }}>
                                                                <div className="equity-details">
                                                                    <div className="bond-cols">
                                                                        <div className="input-item-with-label">
                                                                            <label
                                                                                htmlFor="settled_value"
                                                                                className="form-dropdown-label"
                                                                                style={{ width: "100px" }}
                                                                            >
                                                                                {t('value').toUpperCase()}
                                                                            </label>
                                                                            <input
                                                                                id="settled_value"
                                                                                name="settled_value"
                                                                                type="text"
                                                                                placeholder="0.00"
                                                                                className="form-input-item"
                                                                                style={{ width: "170px", textAlign: "end" }}
                                                                                value={tradeData?.execution_fc_amount}
                                                                                onChange={(e) => handleSetTradeData("execution_fc_amount", e.target.value)}
                                                                                disabled={true}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className="equity-cols">
                                                                        <div className="input-item-with-label">
                                                                            <label
                                                                                htmlFor="settled_price"
                                                                                className="form-dropdown-label"
                                                                                style={{ width: "100px" }}
                                                                            >
                                                                                {t('price').toUpperCase()}
                                                                            </label>
                                                                            <input
                                                                                id="settled_price"
                                                                                name="settled_price"
                                                                                type="text"
                                                                                placeholder="0.00"
                                                                                className="form-input-item"
                                                                                style={{ width: "170px", textAlign: "end" }}
                                                                                value={tradeData?.execution_price}
                                                                                disabled={documentEnabled === "N"}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className="bond-cols">
                                                                        <div className="input-item-with-label">
                                                                            <label
                                                                                htmlFor="settled_qty"
                                                                                className="form-dropdown-label"
                                                                                style={{ width: "max-content" }}
                                                                            >
                                                                                {t('units').toUpperCase()}
                                                                            </label>
                                                                            <input
                                                                                id="settled_qty"
                                                                                name="settled_qty"
                                                                                type="text"
                                                                                placeholder="0.00"
                                                                                className="form-input-item"
                                                                                style={{ width: "200px", textAlign: "end" }}
                                                                                value={tradeData?.executed_quantity}
                                                                                disabled={documentEnabled === "N"}
                                                                            />
                                                                        </div>

                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    }
                                                </div>
                                            }
                                            {/* VIEW FOR TBILL. SHARING WITH BONDS */}
                                            {tradeData?.security_type === "T-Bill" &&
                                                <div className="tbill-wrapper">
                                                    <div className="tbill-details">
                                                        <div className="tbill-cols">
                                                            <div className="input-item-with-label">
                                                                <label
                                                                    htmlFor="market_type"
                                                                    className="form-dropdown-label" style={{ width: "100px" }}
                                                                >
                                                                    {t('market').toUpperCase()}
                                                                </label>
                                                                {documentEnabled === "Y" ?
                                                                    <Select
                                                                        id="market_type"
                                                                        name="market_type"
                                                                        menuPortalTarget={document.body}
                                                                        styles={{
                                                                            ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                                                            menuPortal: base => ({
                                                                                ...base,
                                                                                zIndex: 9999,
                                                                            })
                                                                        }}
                                                                        width="170px"
                                                                        value={marketTypes.find(option => option.value === tradeData?.market_type) || null}
                                                                        onChange={selectedOption => handleSetTradeData("market_type", selectedOption?.value)}
                                                                        options={marketTypes}
                                                                        isSearchable={true}
                                                                        placeholder={t('priority').toUpperCase()}
                                                                        isDisabled={documentEnabled === "N"}
                                                                    /> :
                                                                    <input
                                                                        id="market_type_xx"
                                                                        name="market_type_xx"
                                                                        type="text"
                                                                        className="form-input-item"
                                                                        style={{ width: "170px" }}
                                                                        value={tradeData?.market_type}
                                                                        disabled={true}
                                                                    />}
                                                            </div>
                                                            <div className="input-item-with-label">
                                                                <label
                                                                    htmlFor="face_value_fc"
                                                                    className="form-dropdown-label"
                                                                    style={{ width: "100px" }}
                                                                >
                                                                    {t('faceValue').toUpperCase()}
                                                                </label>
                                                                <input
                                                                    id="face_value_fc"
                                                                    name="face_value_fc"
                                                                    type="text"
                                                                    placeholder="0.00"
                                                                    className="form-input-item"
                                                                    style={{ width: "170px", textAlign: "end" }}
                                                                    value={tradeData?.face_value_fc}
                                                                    onChange={(e) => handleSetTradeData("face_value_fc", e.target.value)}
                                                                    onBlur={(e) => {
                                                                        try {
                                                                            if (e.target.value) {
                                                                                const strippedValue = parseFloat(formatStringToNumberV2(e.target.value));
                                                                                if (isNaN(strippedValue)) {
                                                                                    setNotifyDialogTitle("Error!");
                                                                                    setNotifyDialogText(`Invalid Number <strong>${strippedValue}</strong>`);
                                                                                    setIsNotifyDialogOpen(true);
                                                                                    return;
                                                                                }
                                                                                handleSetTradeData("face_value_fc", formatAmountsToDecimals(strippedValue || 0, 2));
                                                                                handleSetTradeData("clean_price_fc", formatAmountsToDecimals(strippedValue || 0, 2));
                                                                                const rate = parseFloat(tradeData?.hd_cur_rate || 1);
                                                                                const lcAmount = parseFloat((strippedValue * rate).toFixed(4));
                                                                                handleSetTradeData("face_value_lc", formatAmountsToDecimals(lcAmount || 0, 2));
                                                                                handleSetTradeData("clean_price_lc", formatAmountsToDecimals(lcAmount || 0, 2));
                                                                            }
                                                                        } catch (error) {
                                                                            console.log(error)
                                                                        }
                                                                    }}
                                                                    disabled={documentEnabled === "N"}
                                                                />
                                                            </div>
                                                            <div className="input-item-with-label">
                                                                <label
                                                                    htmlFor="discount_rate"
                                                                    className="form-dropdown-label"
                                                                    style={{ width: "100px" }}
                                                                >
                                                                    {t('discount').toUpperCase()}
                                                                </label>
                                                                <input
                                                                    id="discount_rate"
                                                                    name="discount_rate"
                                                                    type="text"
                                                                    placeholder="0.00"
                                                                    className="form-input-item"
                                                                    style={{ width: "170px", textAlign: "end" }}
                                                                    value={tradeData?.tbill_discount_rate}
                                                                    onChange={(e) => handleSetTradeData("tbill_discount_rate", e.target.value)}
                                                                    onBlur={(e) => {
                                                                        try {
                                                                            if (e.target.value) {
                                                                                const strippedValue = parseFloat(formatStringToNumberV2(e.target.value));
                                                                                if (isNaN(strippedValue)) {
                                                                                    setNotifyDialogTitle("Error!");
                                                                                    setNotifyDialogText(`Invalid Number <strong>${strippedValue}</strong>`);
                                                                                    setIsNotifyDialogOpen(true);
                                                                                    return;
                                                                                }
                                                                                handleSetTradeData("tbill_discount_rate", formatAmountsToDecimals(strippedValue || 0, 6));
                                                                                refreshTbillNumbers();
                                                                            }
                                                                        } catch (error) {
                                                                            console.log(error)
                                                                        }
                                                                    }}
                                                                    disabled={documentEnabled === "N"}
                                                                />
                                                            </div>
                                                            <div className="input-item-with-label">
                                                                <label
                                                                    htmlFor="tbill_quantity"
                                                                    className="form-dropdown-label"
                                                                    style={{ width: "100px" }}
                                                                >
                                                                    {t('qty').toUpperCase()}
                                                                </label>
                                                                <input
                                                                    id="tbill_quantity"
                                                                    name="tbill_quantity"
                                                                    type="text"
                                                                    placeholder="0.00"
                                                                    className="form-input-item"
                                                                    style={{ width: "170px", textAlign: "end" }}
                                                                    value={tradeData?.tbill_quantity}
                                                                    onChange={(e) => handleSetTradeData("tbill_quantity", e.target.value)}
                                                                    disabled={documentEnabled === "N"}
                                                                />
                                                            </div>
                                                            {tradeData?.market_type === "Secondary" &&
                                                                <div className="input-item-with-label">
                                                                    <label
                                                                        htmlFor="day_count_convention"
                                                                        className="form-dropdown-label"
                                                                        style={{ width: "100px" }}
                                                                    >
                                                                        {t('days').toUpperCase()}
                                                                    </label>
                                                                    {documentEnabled === "Y" ?
                                                                        <Select
                                                                            id="convention"
                                                                            name="convention"
                                                                            menuPortalTarget={document.body}
                                                                            styles={{
                                                                                ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                                                                menuPortal: base => ({
                                                                                    ...base,
                                                                                    zIndex: 9999,
                                                                                })
                                                                            }}
                                                                            width="170px"
                                                                            value={conventions.find(option => option.value === tradeData?.day_count_convention) || null}
                                                                            onChange={selectedOption => handleSetTradeData("day_count_convention", selectedOption?.value)}
                                                                            options={conventions}
                                                                            isSearchable={true}
                                                                            placeholder={t('convention').toUpperCase()}
                                                                            isDisabled={documentEnabled === "N" || tradeData?.market_type === "Primary"}
                                                                        /> :
                                                                        <input
                                                                            id="convention_xx"
                                                                            name="convention_xx"
                                                                            type="text"
                                                                            className="form-input-item"
                                                                            style={{ width: "170px" }}
                                                                            value={tradeData?.day_count_convention}
                                                                            disabled={true}
                                                                        />}
                                                                </div>}
                                                            {tradeData?.market_type === "Secondary" &&
                                                                <div className="input-item-with-label">
                                                                    <label
                                                                        htmlFor="accrued_interest"
                                                                        className="form-dropdown-label"
                                                                        style={{ width: "max-content" }}
                                                                    >
                                                                        {t('accruedInt').toUpperCase()}
                                                                    </label>
                                                                    <input
                                                                        id="accrued_interest"
                                                                        name="accrued_interest"
                                                                        type="text"
                                                                        placeholder="0.00"
                                                                        className="form-input-item"
                                                                        style={{ width: "170px", textAlign: "end" }}
                                                                        value={tradeData?.accrued_interest}
                                                                        onChange={(e) => handleSetTradeData("accrued_interest", e.target.value)}
                                                                        disabled={true}
                                                                    />
                                                                </div>}
                                                        </div>
                                                        <div className="tbill-cols">

                                                            <div className="input-item-with-label">
                                                                <label
                                                                    htmlFor="tbill_start_date"
                                                                    className="form-dropdown-label"
                                                                    style={{ width: "80px" }}
                                                                >
                                                                    {t('from').toUpperCase()}
                                                                </label>
                                                                <input
                                                                    id="tbill_start_date"
                                                                    name="tbill_start_date"
                                                                    type="date"
                                                                    placeholder={t('settlement').toUpperCase()}
                                                                    className="form-input-item"
                                                                    style={{ width: "170px" }}
                                                                    value={tradeData?.tbill_start_date}
                                                                    onChange={(e) => {
                                                                        try {
                                                                            const formattedDate = moment(e.target.value).format("YYYY-MM-DD");
                                                                            handleSetTradeData("tbill_start_date", formattedDate);
                                                                            refreshTbillNumbers();
                                                                        } catch (error) {
                                                                            console.log(error);
                                                                        }
                                                                    }}
                                                                    disabled={documentEnabled === "N"}
                                                                />
                                                            </div>

                                                            <div className="input-item-with-label">
                                                                <label
                                                                    htmlFor="tbill_tenor"
                                                                    className="form-dropdown-label"
                                                                    style={{ width: "80px" }}
                                                                >
                                                                    {t('days').toUpperCase()}
                                                                </label>
                                                                <input
                                                                    id="tbill_tenor"
                                                                    name="tbill_tenor"
                                                                    type="text"
                                                                    placeholder="0"
                                                                    className="form-input-item"
                                                                    style={{ width: "170px", textAlign: "end" }}
                                                                    value={tradeData?.tbill_tenor}
                                                                    onChange={(e) => handleSetTradeData("tbill_tenor", e.target.value)}
                                                                    onBlur={(e) => {
                                                                        try {
                                                                            if (e.target.value) {
                                                                                const strippedValue = parseFloat(formatStringToNumberV2(e.target.value));
                                                                                if (isNaN(strippedValue)) {
                                                                                    setNotifyDialogTitle("Error!");
                                                                                    setNotifyDialogText(`Invalid Number <strong>${strippedValue}</strong>`);
                                                                                    setIsNotifyDialogOpen(true);
                                                                                    return;
                                                                                }
                                                                                handleSetTradeData("tbill_tenor", formatAmountsToDecimals(strippedValue || 0, 0));
                                                                                refreshTbillNumbers();
                                                                            }
                                                                        } catch (error) {
                                                                            console.log(error)
                                                                        }
                                                                    }}
                                                                    disabled={documentEnabled === "N"}
                                                                />
                                                            </div>
                                                            <div className="input-item-with-label">
                                                                <label
                                                                    htmlFor="tbill_maturity_date"
                                                                    className="form-dropdown-label"
                                                                    style={{ width: "80px" }}
                                                                >
                                                                    {t('to').toUpperCase()}
                                                                </label>
                                                                <input
                                                                    id="tbill_maturity_date"
                                                                    name="tbill_maturity_date"
                                                                    type="date"
                                                                    placeholder={t('settlement').toUpperCase()}
                                                                    className="form-input-item"
                                                                    style={{ width: "170px" }}
                                                                    value={tradeData?.tbill_maturity_date}
                                                                    onChange={(e) => {
                                                                        try {
                                                                            const formattedDate = moment(e.target.value).format("YYYY-MM-DD");
                                                                            handleSetTradeData("tbill_maturity_date", formattedDate);
                                                                        } catch (error) {
                                                                            console.log(error);
                                                                        }
                                                                    }}
                                                                    disabled={true}
                                                                />
                                                            </div>
                                                            {tradeData?.market_type === "Secondary" &&
                                                                <div className="input-item-with-label">
                                                                    <label
                                                                        htmlFor="last_coupon_date"
                                                                        className="form-dropdown-label"
                                                                        style={{ width: "80px" }}
                                                                    >
                                                                        {t('lastCoupon').toUpperCase()}
                                                                    </label>
                                                                    <input
                                                                        id="last_coupon_date"
                                                                        name="last_coupon_date"
                                                                        type="date"
                                                                        placeholder={t('lastCoupon').toUpperCase()}
                                                                        className="form-input-item"
                                                                        style={{ width: "170px" }}
                                                                        value={tradeData?.last_coupon_date}
                                                                        onChange={(e) => {
                                                                            try {
                                                                                const formattedDate = moment(e.target.value).format("YYYY-MM-DD");
                                                                                handleSetTradeData("last_coupon_date", formattedDate);
                                                                            } catch (error) {
                                                                                console.log(error);
                                                                            }
                                                                        }}
                                                                        disabled={documentEnabled === "N" || tradeData?.market_type === "Primary"}
                                                                    />
                                                                </div>}
                                                        </div>
                                                        <div className="tbill-cols">
                                                            <div className="input-item-with-label">
                                                                <label
                                                                    htmlFor="tbill_fc"
                                                                    className="form-dropdown-label"
                                                                    style={{ width: "100px" }}
                                                                >
                                                                    {t('invested').toUpperCase()}
                                                                </label>
                                                                <input
                                                                    id="tbill_fc"
                                                                    name="tbill_fc"
                                                                    type="text"
                                                                    placeholder="0.00"
                                                                    className="form-input-item"
                                                                    style={{ width: "200px", textAlign: "end" }}
                                                                    value={tradeData?.hd_fc_amount}
                                                                    onChange={(e) => handleSetTradeData("hd_fc_amount", e.target.value)}
                                                                    disabled={true}
                                                                />
                                                            </div>
                                                            <div className="input-item-with-label">
                                                                <label
                                                                    htmlFor="tbill_discount_fc"
                                                                    className="form-dropdown-label"
                                                                    style={{ width: "100px" }}
                                                                >
                                                                    {t('discounted').toUpperCase()}
                                                                </label>
                                                                <input
                                                                    id="tbill_discount_fc"
                                                                    name="tbill_discount_fc"
                                                                    type="text"
                                                                    placeholder="0.00"
                                                                    className="form-input-item"
                                                                    style={{ width: "200px", textAlign: "end" }}
                                                                    value={tradeData?.tbill_discount_fc}
                                                                    onChange={(e) => handleSetTradeData("tbill_discount_fc", e.target.value)}
                                                                    disabled={true}
                                                                />
                                                            </div>

                                                            <div className="input-item-with-label">
                                                                <label
                                                                    htmlFor="yield"
                                                                    className="form-dropdown-label"
                                                                    style={{ width: "100px" }}
                                                                >
                                                                    {t('yield').toUpperCase()}
                                                                </label>
                                                                <input
                                                                    id="yield"
                                                                    name="yield"
                                                                    type="text"
                                                                    placeholder="0.00"
                                                                    className="form-input-item"
                                                                    style={{ width: "200px", textAlign: "end" }}
                                                                    value={tradeData?.tbill_yeild_maturity}
                                                                    onChange={(e) => handleSetTradeData("tbill_yeild_maturity", e.target.value)}
                                                                    disabled={true}
                                                                />
                                                            </div>
                                                            <div className="input-item-with-label">
                                                                <label
                                                                    htmlFor="tbill_price_fc"
                                                                    className="form-dropdown-label"
                                                                    style={{ width: "100px" }}
                                                                >
                                                                    {t('price').toUpperCase()}
                                                                </label>
                                                                <input
                                                                    id="tbill_price_fc"
                                                                    name="tbill_price_fc"
                                                                    type="text"
                                                                    placeholder="0.00"
                                                                    className="form-input-item"
                                                                    style={{ width: "200px", textAlign: "end" }}
                                                                    value={tradeData?.tbill_price_fc}
                                                                    onChange={(e) => handleSetTradeData("tbill_price_fc", e.target.value)}
                                                                    onBlur={(e) => {
                                                                        try {
                                                                            if (e.target.value) {
                                                                                const strippedValue = parseFloat(formatStringToNumberV2(e.target.value));
                                                                                if (isNaN(strippedValue)) {
                                                                                    setNotifyDialogTitle("Error!");
                                                                                    setNotifyDialogText(`Invalid Number <strong>${strippedValue}</strong>`);
                                                                                    setIsNotifyDialogOpen(true);
                                                                                    return;
                                                                                }
                                                                                handleSetTradeData("tbill_price_fc", formatAmountsToDecimals(strippedValue || 0, 0));
                                                                            }
                                                                        } catch (error) {
                                                                            console.log(error)
                                                                        }
                                                                    }}
                                                                    disabled={documentEnabled === "N"}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {/* SHOWN AFTER EXECUTION */}
                                                    {tradeData?.settlement_status === "Settled" &&
                                                        <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
                                                            <hr className="separator-h" />
                                                            <span className="status Critical sub-title" style={{ marginLeft: "30px" }} >{`${t('executed').toUpperCase()} ${tradeData?.executed_prompt_xx}`}</span>
                                                            <div className="tbill-wrapper" style={{ marginTop: "10px" }}>
                                                                <div className="tbill-details">
                                                                    <div className="tbill-cols">
                                                                        <div className="input-item-with-label">
                                                                            <label
                                                                                htmlFor="settled_value"
                                                                                className="form-dropdown-label"
                                                                                style={{ width: "100px" }}
                                                                            >
                                                                                {t('value').toUpperCase()}
                                                                            </label>
                                                                            <input
                                                                                id="settled_value"
                                                                                name="settled_value"
                                                                                type="text"
                                                                                placeholder="0.00"
                                                                                className="form-input-item"
                                                                                style={{ width: "170px", textAlign: "end" }}
                                                                                value={tradeData?.execution_fc_amount}
                                                                                onChange={(e) => handleSetTradeData("execution_fc_amount", e.target.value)}
                                                                                disabled={true}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className="tbill-cols">
                                                                        <div className="input-item-with-label">
                                                                            <label
                                                                                htmlFor="settled_price"
                                                                                className="form-dropdown-label"
                                                                                style={{ width: "100px" }}
                                                                            >
                                                                                {t('price').toUpperCase()}
                                                                            </label>
                                                                            <input
                                                                                id="settled_price"
                                                                                name="settled_price"
                                                                                type="text"
                                                                                placeholder="0.00"
                                                                                className="form-input-item"
                                                                                style={{ width: "170px", textAlign: "end" }}
                                                                                value={tradeData?.execution_price}
                                                                                disabled={documentEnabled === "N"}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className="tbill-cols">
                                                                        <div className="input-item-with-label">
                                                                            <label
                                                                                htmlFor="settled_qty"
                                                                                className="form-dropdown-label"
                                                                                style={{ width: "max-content" }}
                                                                            >
                                                                                {t('units').toUpperCase()}
                                                                            </label>
                                                                            <input
                                                                                id="settled_qty"
                                                                                name="settled_qty"
                                                                                type="text"
                                                                                placeholder="0.00"
                                                                                className="form-input-item"
                                                                                style={{ width: "200px", textAlign: "end" }}
                                                                                value={tradeData?.executed_quantity}
                                                                                disabled={documentEnabled === "N"}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    }
                                                </div>
                                            }
                                            {/* VIEW FOR FIXED DEPOSIT */}
                                            {tradeData?.security_type === "Deposit" &&
                                                <div className="fdeposit-wrapper">
                                                    <div className="fdeposit-details">
                                                        <div className="fdeposit-cols">
                                                            <div className="input-item-with-label">
                                                                <label
                                                                    htmlFor="fd_principal_fc"
                                                                    className="form-dropdown-label"
                                                                    style={{ width: "100px" }}
                                                                >
                                                                    {t('principal').toUpperCase()}
                                                                </label>
                                                                <input
                                                                    id="fd_principal_fc"
                                                                    name="fd_principal_fc"
                                                                    type="text"
                                                                    placeholder="0.00"
                                                                    className="form-input-item"
                                                                    style={{ width: "170px", textAlign: "end" }}
                                                                    value={tradeData?.fd_principal_fc}
                                                                    onChange={(e) => handleSetTradeData("fd_principal_fc", e.target.value)}
                                                                    onBlur={(e) => {
                                                                        try {
                                                                            if (e.target.value) {
                                                                                const strippedValue = parseFloat(formatStringToNumberV2(e.target.value));
                                                                                if (isNaN(strippedValue)) {
                                                                                    setNotifyDialogTitle("Error!");
                                                                                    setNotifyDialogText(`Invalid Number <strong>${strippedValue}</strong>`);
                                                                                    setIsNotifyDialogOpen(true);
                                                                                    return;
                                                                                }
                                                                                handleSetTradeData("fd_principal_fc", formatAmountsToDecimals(strippedValue || 0, 2));
                                                                                const rate = parseFloat(tradeData?.hd_cur_rate || 1);
                                                                                const lcAmount = parseFloat((strippedValue * rate).toFixed(4));
                                                                                handleSetTradeData("fd_principal_lc", formatAmountsToDecimals(lcAmount || 0, 2));
                                                                            }
                                                                        } catch (error) {
                                                                            console.log(error);
                                                                        }
                                                                    }}
                                                                    disabled={documentEnabled === "N"}
                                                                />
                                                            </div>
                                                            <div className="input-item-with-label">
                                                                <label
                                                                    htmlFor="fd_interest_rate"
                                                                    className="form-dropdown-label"
                                                                    style={{ width: "100px" }}
                                                                >
                                                                    {t('interest').toUpperCase()}
                                                                </label>
                                                                <input
                                                                    id="fd_interest_rate"
                                                                    name="fd_interest_rate"
                                                                    type="text"
                                                                    placeholder="0.00"
                                                                    className="form-input-item"
                                                                    style={{ width: "170px", textAlign: "end" }}
                                                                    value={tradeData?.fd_interest_rate}
                                                                    onChange={(e) => handleSetTradeData("fd_interest_rate", e.target.value)}
                                                                    onBlur={(e) => {
                                                                        try {
                                                                            if (e.target.value) {
                                                                                const strippedValue = parseFloat(formatStringToNumberV2(e.target.value));
                                                                                if (isNaN(strippedValue)) {
                                                                                    setNotifyDialogTitle("Error!");
                                                                                    setNotifyDialogText(`Invalid Number <strong>${strippedValue}</strong>`);
                                                                                    setIsNotifyDialogOpen(true);
                                                                                    return;
                                                                                }
                                                                                handleSetTradeData("fd_interest_rate", formatAmountsToDecimals(strippedValue || 0, 6));
                                                                                refreshFixedDeposit();
                                                                            }
                                                                        } catch (error) {
                                                                            console.log(error);
                                                                        }
                                                                    }}
                                                                    disabled={documentEnabled === "N"}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="fdeposit-cols">
                                                            <div className="input-item-with-label">
                                                                <label
                                                                    htmlFor="fd_start_date"
                                                                    className="form-dropdown-label"
                                                                    style={{ width: "80px" }}
                                                                >
                                                                    {t('from').toUpperCase()}
                                                                </label>
                                                                <input
                                                                    id="fd_start_date"
                                                                    name="fd_start_date"
                                                                    type="date"
                                                                    placeholder={t('from').toUpperCase()}
                                                                    className="form-input-item"
                                                                    style={{ width: "170px" }}
                                                                    value={tradeData?.fd_start_date}
                                                                    onChange={(e) => {
                                                                        try {
                                                                            const formattedDate = moment(e.target.value).format("YYYY-MM-DD");
                                                                            handleSetTradeData("fd_start_date", formattedDate);
                                                                        } catch (error) {
                                                                            console.log(error);
                                                                        }
                                                                    }}
                                                                    onBlur={(e) => refreshFixedDeposit()}
                                                                    disabled={documentEnabled === "N"}
                                                                />
                                                            </div>
                                                            <div className="input-item-with-label">
                                                                <label
                                                                    htmlFor="fd_tenor_in_days"
                                                                    className="form-dropdown-label"
                                                                    style={{ width: "80px" }}
                                                                >
                                                                    {t('tenorInDays').toUpperCase()}
                                                                </label>
                                                                <input
                                                                    id="fd_tenor_in_days"
                                                                    name="fd_tenor_in_days"
                                                                    type="text"
                                                                    placeholder="0"
                                                                    className="form-input-item"
                                                                    style={{ width: "170px", textAlign: "end" }}
                                                                    value={tradeData?.fd_tenor_in_days}
                                                                    onChange={(e) => handleSetTradeData("fd_tenor_in_days", e.target.value)}
                                                                    onBlur={(e) => {
                                                                        try {
                                                                            if (e.target.value) {
                                                                                const strippedValue = parseFloat(formatStringToNumberV2(e.target.value));
                                                                                if (isNaN(strippedValue)) {
                                                                                    setNotifyDialogTitle("Error!");
                                                                                    setNotifyDialogText(`Invalid Number <strong>${strippedValue}</strong>`);
                                                                                    setIsNotifyDialogOpen(true);
                                                                                    return;
                                                                                }
                                                                                refreshFixedDeposit();
                                                                            }
                                                                        } catch (error) {
                                                                            console.log(error)
                                                                        }
                                                                    }}
                                                                    disabled={documentEnabled === "N"}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="fdeposit-cols">
                                                            <div className="input-item-with-label">
                                                                <label
                                                                    htmlFor="fd_maturity_date"
                                                                    className="form-dropdown-label"
                                                                    style={{ width: "100px" }}
                                                                >
                                                                    {t('to').toUpperCase()}
                                                                </label>
                                                                <input
                                                                    id="fd_maturity_date"
                                                                    name="fd_maturity_date"
                                                                    type="date"
                                                                    placeholder={t('to').toUpperCase()}
                                                                    className="form-input-item"
                                                                    style={{ width: "200px" }}
                                                                    value={tradeData?.fd_maturity_date}
                                                                    onChange={(e) => {
                                                                        try {
                                                                            const formattedDate = moment(e.target.value).format("YYYY-MM-DD");
                                                                            handleSetTradeData("fd_maturity_date", formattedDate);
                                                                        } catch (error) {
                                                                            console.log(error);
                                                                        }
                                                                    }}
                                                                    disabled={true}
                                                                />
                                                            </div>
                                                            <div className="input-item-with-label">
                                                                <label
                                                                    htmlFor="fd_interest_fc"
                                                                    className="form-dropdown-label"
                                                                    style={{ width: "100px" }}
                                                                >
                                                                    {t('interest').toUpperCase()}
                                                                </label>
                                                                <input
                                                                    id="fd_interest_fc"
                                                                    name="fd_interest_fc"
                                                                    type="text"
                                                                    placeholder="0"
                                                                    className="form-input-item"
                                                                    style={{ width: "200px", textAlign: "end" }}
                                                                    value={tradeData?.fd_interest_fc}
                                                                    onChange={(e) => handleSetTradeData("fd_interest_fc", e.target.value)}
                                                                    disabled={true}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                            {/* VIEW FOR ETF */}
                                            {tradeData?.security_type === "ETF" &&
                                                <div className="etf-wrapper">
                                                    <div className="etf-details">etf-details</div>
                                                </div>
                                            }
                                        </ExpandableComponent>
                                        {/* fees */}
                                        <ExpandableComponent
                                            title={t('fees').toUpperCase()}
                                            subtitle={
                                                <span className="main-title" style={{ fontSize: "18px" }}>{`${t('totalFees')} : ${tradeData?.hd_cur_code} ${numeral(totalFeesFc).format("0,0.00")}`}</span>
                                            }
                                            defaultExpanded={true}
                                        >
                                            <div className="available-services">
                                                <div className="table-content">
                                                    <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }} className="table-container">
                                                        <Table sx={{ width: "max-content", border: 'none' }}>
                                                            <TableHead className="tablehead">
                                                                <TableRow className="tablerow">
                                                                    <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                                                        #
                                                                    </TableCell>
                                                                    <TableCell className="table-cell left" style={{ width: "auto" }}>
                                                                        {documentEnabled === "Y" ?
                                                                            <div className="input-item-with-label" style={{ width: "100%", gap: "5px" }}>
                                                                                <Select
                                                                                    id="fee"
                                                                                    name="fee"
                                                                                    menuPortalTarget={document.body}
                                                                                    styles={{
                                                                                        ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                                                                        menuPortal: base => ({
                                                                                            ...base,
                                                                                            zIndex: 9999,
                                                                                        })
                                                                                    }}
                                                                                    width="100%"
                                                                                    dropdownHeight={4 * 42}
                                                                                    value={selectedDefinedFee}
                                                                                    onChange={(selectedOption) => {
                                                                                        try {
                                                                                            setSelectedDefinedFee(selectedOption);
                                                                                        } catch (error) {
                                                                                            console.log(error);
                                                                                        }
                                                                                    }}
                                                                                    options={definedFees}
                                                                                    isSearchable={true}
                                                                                    placeholder={t('fee')}
                                                                                />
                                                                                <CircularButton
                                                                                    currentTheme={currentTheme}
                                                                                    onClick={async (e) => {
                                                                                        try {
                                                                                            if (!selectedDefinedFee) {
                                                                                                setNotifyDialogTitle("Note!");
                                                                                                setNotifyDialogText(`Please select fee to add!`);
                                                                                                setIsNotifyDialogOpen(true);
                                                                                                return;
                                                                                            }

                                                                                            let fcAmount = 0;
                                                                                            let lcAmount = 0;

                                                                                            if (parseFloat(selectedDefinedFee?.sys_flex2) && selectedDefinedFee?.sys_flex1) {
                                                                                                fcAmount = (parseFloat(selectedDefinedFee?.sys_flex2) / 100) * parseFloat(formatStringToNumberV2(tradeData?.hd_fc_amount || 0, 4));
                                                                                                lcAmount = parseFloat((fcAmount * tradeData?.hd_cur_rate || 1).toFixed(4));
                                                                                            }

                                                                                            const res = await newRequest.post("/trade/addFee",
                                                                                                {
                                                                                                    trade_docid: tradeDocId,
                                                                                                    ln_hd_no: tradeData?.hd_no,
                                                                                                    fee_code: selectedDefinedFee?.value,
                                                                                                    fee_type: selectedDefinedFee?.fee_type,
                                                                                                    rate: parseFloat(selectedDefinedFee?.sys_flex2) || 0,
                                                                                                    rate_type: selectedDefinedFee?.sys_flex1 || "Percentage",
                                                                                                    fee_amount_fc: fcAmount,
                                                                                                    fee_amount_lc: lcAmount,
                                                                                                    currency: tradeData?.hd_cur_code,
                                                                                                    description: selectedDefinedFee?.label,
                                                                                                });

                                                                                            if (res.data?.msg === "added") {
                                                                                                setTradeFees((prevData) => [...prevData, {
                                                                                                    ...res.data?.doc,
                                                                                                    rate: formatAmountsToDecimals(res.data?.doc?.rate || 0)
                                                                                                }]);
                                                                                                setSelectedDefinedFee(null);
                                                                                                showToast("Added!", "success");
                                                                                            } else if (res.data?.msg === "exists") {
                                                                                                showToast(`${selectedDefinedFee?.label} is already added to this transaction`, "warning");
                                                                                            } else {
                                                                                                showToast(res.data?.msg, "error");
                                                                                            }
                                                                                        } catch (error) {
                                                                                            console.log(error);
                                                                                        }
                                                                                    }}
                                                                                    icon={<MdAdd color="green" />} width={"35px"} height={"35px"} />
                                                                            </div>
                                                                            :
                                                                            <span>{t('fee').toUpperCase()}</span>}
                                                                    </TableCell>
                                                                    {/* <TableCell className="table-cell right" style={{ maxWidth: "120px" }}>
                                                                        <span style={{ maxWidth: "120px" }} />
                                                                    </TableCell>
                                                                    <TableCell className="table-cell" style={{ maxWidth: "175px" }}>
                                                                        <span style={{ maxWidth: "175px" }} />
                                                                    </TableCell> */}
                                                                    <TableCell className="table-cell right" style={{ maxWidth: "150px" }}>
                                                                        <span>{`${t('amount').toUpperCase()} [${tradeData?.hd_cur_code}]`}</span>
                                                                    </TableCell>
                                                                    {documentEnabled === "Y" &&
                                                                        <TableCell className="table-cell center" style={{ maxWidth: "80px" }}>
                                                                            <span>{`${t('action').toUpperCase()}`}</span>
                                                                        </TableCell>}
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody className="tablebody">
                                                                {tradeFees?.map((row, index) => (
                                                                    <TableRow
                                                                        key={row?._id}
                                                                        className={`${selectedFee?._id === row?._id ? "tablerow current" : "tablerow"}`}
                                                                        onClick={() => {
                                                                            try {
                                                                                setSelectedFee(row);
                                                                            } catch (error) {
                                                                                console.log(error);
                                                                            }
                                                                        }}
                                                                    >
                                                                        <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                                                            {index + 1}
                                                                        </TableCell>
                                                                        <TableCell className="table-cell left" style={{ width: "auto" }}>
                                                                            <div style={{ display: "flex", flexDirection: "column", gap: "2px", width: "100%" }}>
                                                                                <span className="sub-title">{row?.fee_name_xx}</span>
                                                                                <div style={{ display: "flex", flexDirection: "row", gap: "5px", width: "100%" }}>
                                                                                    <span className="sub-title" style={{ fontSize: "10px" }}>{row?.fee_category_xx}</span>
                                                                                    <span className="sub-title soft" style={{ fontSize: "10px" }}>{`[${row?.fee_code}]`}</span>
                                                                                </div>
                                                                            </div>
                                                                        </TableCell>
                                                                        <TableCell className="table-cell right" style={{ maxWidth: "120px" }}>
                                                                            {documentEnabled === "Y" ?
                                                                                <div className="input-item-with-label">
                                                                                    <input
                                                                                        id={`rate_${row?._id}`}
                                                                                        name={`rate_${row?._id}`}
                                                                                        type="text"
                                                                                        value={row?.rate}
                                                                                        onChange={(e) => handleTradeFeeChange(e, row?._id, 'rate')}
                                                                                        onBlur={() => handleTradeFeeBlur(row?._id, "rate")}
                                                                                        style={{ width: "115px", textAlign: "right" }}
                                                                                        className="form-input-item table"
                                                                                    />
                                                                                </div>
                                                                                :
                                                                                <span className="sub-title">{`${t('rate')} : ${row?.rate_type === "Fixed Amount" ? tradeData?.hd_cur_code : ""} ${numeral(row?.rate).format("0,0.00")} ${row?.rate_type === "Percentage" ? "%" : ""}`}</span>}
                                                                        </TableCell>
                                                                        <TableCell className="table-cell" style={{ maxWidth: "175px" }}>
                                                                            {documentEnabled === "Y" ?
                                                                                <div className="input-item-with-label">
                                                                                    <Select
                                                                                        id={`rate_type_${row?._id}`}
                                                                                        name={`rate_type_${row?._id}`}
                                                                                        menuPortalTarget={document.body}
                                                                                        styles={{
                                                                                            ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                                                                            menuPortal: base => ({
                                                                                                ...base,
                                                                                                zIndex: 9999,
                                                                                            })
                                                                                        }}
                                                                                        width="170px"
                                                                                        height="36px"
                                                                                        options={rateTypes}
                                                                                        isSearchable={true}
                                                                                        placeholder={t('type')}
                                                                                        value={rateTypes.find(option => option.value === row?.rate_type) || null}
                                                                                        onChange={(selectedOption) => handleTradeFeeChange(selectedOption, row?._id, 'rate_type')}
                                                                                        onBlur={() => handleTradeFeeBlur(row?._id, "rate_type")}
                                                                                    />
                                                                                </div>
                                                                                :
                                                                                <span className="sub-title">{`${t('type')} : ${row?.rate_type}`}</span>}
                                                                        </TableCell>
                                                                        <TableCell className="table-cell right" style={{ maxWidth: "150px" }}>
                                                                            <span>{numeral(row?.fee_amount_fc).format("0,0.00")}</span>
                                                                        </TableCell>
                                                                        {documentEnabled === "Y" &&
                                                                            <TableCell className="table-cell center" style={{ maxWidth: "80px" }}>
                                                                                <CircularButton
                                                                                    currentTheme={currentTheme}
                                                                                    onClick={async (e) => {
                                                                                        try {
                                                                                            const res = await newRequest.delete(`/trade/delFee/${row?._id}`);
                                                                                            if (res.data?.msg === "deleted") {
                                                                                                setTradeFees((prevData) => prevData.filter(doc => doc?._id !== row?._id));
                                                                                                showToast(t('removed'), "success");
                                                                                            } else {
                                                                                                showToast(res.data?.msg, "error");
                                                                                            }
                                                                                        } catch (error) {
                                                                                            console.log(error);
                                                                                        }
                                                                                    }} color="#E53935" icon={<MdDelete/>} width={"30px"} height={"30px"} />
                                                                            </TableCell>}

                                                                    </TableRow>
                                                                ))}
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                </div>
                                            </div>
                                            {/* end of fees */}
                                            {/* coupons payment schedule */}
                                        </ExpandableComponent>
                                        {tradeDocId !== "new" &&
                                            tradeDocId !== undefined &&
                                            ["Bond", "T-Bill"].includes(tradeData?.security_type) &&
                                            <ExpandableComponent
                                                key={refreshKey}
                                                title={t('couponsSchedule').toUpperCase()}
                                                subtitle={<span className="sub-title">{tradeData?.hd_cur_code}</span>}
                                                onSubtitleClick={() => { }}
                                                defaultExpanded={true}
                                            >
                                                <AmSchedule tradeDocid={tradeDocId} hdCurCode={tradeData?.hd_cur_code} />
                                            </ExpandableComponent>}
                                        {/* end of coupons payment schedule */}
                                        {/* T-Account after posting document */}
                                        {["Approved", "Cancelled"].includes(tradeData?.hd_status) &&
                                            <Taccount key={tradeData?.hd_status} originalDocId={tradeDocId} originalDocno={tradeData?.hd_no} originalDocType={"AM Trade"} endorsementIndex={0} />}
                                    </>
                                }
                                {activeTab === 1 && <>
                                    <motion.div
                                        className="tabs-view-wrapper"
                                        initial={{ opacity: 0 }}
                                        animate={{ opacity: 1, transition: { duration: 1 } }}
                                        exit={{ opacity: 0, transition: { duration: 1 } }}>
                                        <div className="attachment">
                                            <FileUploadComponent documentNo={tradeData?.hd_no} documentId={tradeDocId} documentType="am trade" fetchDocumentAttachments={fetchDocumentAttachments} uploadFolder="am_fund_sub" />
                                            <div className="attachment-files">
                                                <AllFiles filesList={attachmentsData} />
                                            </div>
                                        </div>
                                    </motion.div>
                                </>}
                                {activeTab === 2 &&
                                    <motion.div
                                        className="correspondence"
                                        initial={{ opacity: 0 }}
                                        animate={{ opacity: 1, transition: { duration: 1 } }}
                                        exit={{ opacity: 0, transition: { duration: 1 } }}
                                    >
                                        <HRHandbook />
                                    </motion.div>
                                }
                                {activeTab === 3 &&
                                    <motion.div
                                        className="correspondence"
                                        initial={{ opacity: 0 }}
                                        animate={{ opacity: 1, transition: { duration: 1 } }}
                                        exit={{ opacity: 0, transition: { duration: 1 } }}
                                    >
                                        <Correspondence
                                            correspondenceParams={{ fetch_type: "document", doc_id: tradeDocId, doc_no: tradeData?.hd_no, doc_type: "Receipt", entity_codes: [tradeData?.hd_ent_code?.value] }}
                                            passedEmailData={{
                                                to: `${tradeData?.client_email_xx}`,
                                                cc: `${currentUser?.usr_email}`,
                                                bcc: '',
                                                subject: `Receipt No ${tradeData?.hd_no}`,
                                                show_attach: "Y",
                                                attached_urls: [],
                                                binary_docs: [],
                                                doc_no: tradeData?.hd_no,
                                                doc_type: "AM Trade",
                                                doc_id: tradeDocId,
                                                entity_codes: [tradeData?.hd_ent_code?.value],
                                                search_string: tradeData?.hd_ent_code?.label?.props?.children[0] + "," + tradeData?.hd_no,
                                                carrierName: "",
                                                productName: "",
                                                clientName: tradeData?.hd_ent_code?.label?.props?.children[0],
                                                riskNoteNo: tradeData?.hd_no,
                                                daysToRenewal: 0,
                                                expiryDate: "",
                                                insuredName: tradeData?.hd_ent_code?.label?.props?.children[0],
                                                outstandingPremium: 0,
                                                policyCurrency: tradeData?.hd_cur_code,
                                                policyNumber: tradeData?.hd_no,
                                                policyPremium: "",
                                                policyPremiumTotal: "",
                                                policySumInsured: "",
                                                policyFromDate: "",
                                                policyToDate: "",
                                                tpt_category: []
                                            }} />
                                    </motion.div>
                                }
                                {activeTab === 4 &&
                                    <motion.div
                                        className="content-details-row"
                                        initial={{ opacity: 0 }}
                                        animate={{ opacity: 1, transition: { duration: 1 } }}
                                        exit={{ opacity: 0, transition: { duration: 1 } }}
                                    >
                                        <AllDocsNote
                                            docId={tradeData._id}
                                            docType="AM Trade"
                                            noteType={"Normal"}
                                        />
                                    </motion.div>
                                }
                            </div>
                        </div>
                        <div className="trade-summary-wrapper">
                            <div className="summary-content">
                                <WorkedOnBy name={tradeData?.updated_by_name_xx} photoUrl={tradeData?.updated_by_photo_url_xx} time_ago_xx={tradeData?.time_ago_xx} />
                                <hr className="separator-h" />
                                {tradeData?.hd_cur_code !== currentUser?.currency_code_xx && (
                                    <div
                                        className="input-item-with-label"
                                        style={{ alignSelf: "flex-end" }}
                                    >
                                        <label
                                            htmlFor="hd_cur_rate"
                                            className="form-dropdown-label"
                                        >
                                            {t('rate').toUpperCase()}
                                        </label>
                                        <input
                                            id="hd_cur_rate"
                                            name="hd_cur_rate"
                                            type="number"
                                            placeholder="0.00"
                                            value={tradeData?.hd_cur_rate}
                                            className="form-input-item"
                                            style={{
                                                width: "100px",
                                                margin: "5px 0px",
                                                textAlign: "right",
                                            }}
                                            // onChange={(e) => setHdCurRate(e.target.value)}
                                            disabled={documentEnabled === "N"}
                                        />
                                    </div>
                                )}
                                <motion.div
                                    className="summary-view"
                                    initial={{ opacity: 0 }}
                                    animate={{ opacity: 1, transition: { duration: 1 } }}
                                    exit={{ opacity: 0, transition: { duration: 1 } }}
                                >
                                    <div className="title-row">
                                        <span className="sub-title">{t('summary').toUpperCase()}</span>
                                        {currentUser?.currency_code_xx !== tradeData?.hd_cur_code && (
                                            <CustomButtonSmall
                                                style={{ display: "flex" }}
                                                onClick={() => {
                                                    try {
                                                        if (figuresToShow === "org") {
                                                            setFiguresToShow("base");
                                                        } else {
                                                            setFiguresToShow("org");
                                                        }
                                                    } catch (error) {
                                                        console.log(error);
                                                    }
                                                }}
                                            >
                                                {figuresToShow === "org"
                                                    ? `view ${currentUser?.currency_code_xx}`
                                                    : `view ${tradeData?.hd_cur_code}`}
                                            </CustomButtonSmall>
                                        )}
                                        <h1 className="main-title currency">
                                            {figuresToShow === "org"
                                                ? `${tradeData?.hd_cur_code}`
                                                : `${currentUser?.currency_code_xx}`}
                                        </h1>
                                    </div>
                                    <hr className="separator-h" />
                                    <div className="content-row">
                                        <span className="sub-title"> {t('investing').toUpperCase()} </span>
                                        <span span className="receipt-amount">  {numeral(tradeData?.hd_fc_amount).format("0,0.00")}   </span>
                                    </div>
                                    <div className="content-row">
                                        {tradeData?.hd_fc_amount && <span className="amount-to-words">{`${currentUser?.currency_code_xx} ${numberToWordsWithDecimal(tradeData?.hd_fc_amount)}`}</span>}
                                    </div>

                                    <hr className="separator-h" />
                                    <div className="content-row">
                                        <span className="sub-title"> {t('fees').toUpperCase()} </span>
                                        <span span className="receipt-amount"> {numeral(tradeData?.total_fees_lc).format("0,0.00")}   </span>
                                    </div>
                                    <div className="content-row">
                                        <span className="sub-title"> {t('total').toUpperCase()} </span>
                                        <span span className="receipt-amount"> {numeral(tradeData?.gross_amount_lc).format("0,0.00")}  </span>
                                    </div>
                                    <hr className="separator-h" />
                                    <h1 className="sub-title" style={{ textAlign: "center" }}>{t('timeline').toUpperCase()}</h1>
                                    <hr className="separator-h" />
                                    <div className="timeline-root">
                                        {traceData.map((item) => (
                                            <div key={item?._id} className="timeline-item">
                                                <div className="timeline-separator">
                                                    <div className="timeline-dot"></div>
                                                    <div className="timeline-connector" />
                                                </div>
                                                <div className="timeline-content">
                                                    <div className="timeline-navbar">
                                                        <div className="avatar-container">
                                                            {item?.updated_by_photo_url_xx ?
                                                                <img src={item?.updated_by_photo_url_xx} alt="" className="avatar" /> : <CiImageOn style={{ width: "30px", height: "30px" }} />}
                                                            <span className="username">{item?.updated_by_name_xx}</span>
                                                        </div>
                                                        <span className="time-ago">{item?.time_ago_xx}</span>
                                                    </div>
                                                    <div className="remarks">
                                                        {item?.trc_remarks}
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </motion.div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {validationMsgDialog && (
                <motion.div
                    className="overlay-dialog"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1, transition: { duration: 1 } }}
                    exit={{ opacity: 0, transition: { duration: 1 } }}
                >
                    <div className="overlay-wrapper">
                        <div className="overlay-navbar">
                            <h1 className="main-title">{t('messages')}</h1>
                            <CircularButton
                                currentTheme={currentTheme}
                                onClick={() => {
                                    try {
                                        setValidationMsgDialog(false);
                                    } catch (error) {
                                        console.log(error);
                                    }
                                }} icon={<MdClose />} width={"35px"} height={"35px"} />
                        </div>
                        <div className="overlay-content">
                            <ValidationMessages messageData={validationMessagesResult} />
                        </div>
                    </div>
                </motion.div>
            )}

            {/* Dialog to notify user about changes being saved */}
            <Dialog open={isNotifyDialogOpen}
                onClose={handleCloseNotifyDialog}
                PaperProps={{
                    sx: {
                        backgroundColor: currentTheme === "dark" ? "#181A20" : "#fff",
                        color: currentTheme === "dark" ? "#fff" : "#000",
                    },
                }}
                slotProps={{
                    backdrop: {
                        sx: {
                            backgroundColor: "rgba(0, 0, 0, 0.7)",
                        },
                    },
                }}>
                <DialogTitle>{notifyDialogTitle}</DialogTitle>
                <DialogContent>
                    <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(notifyDialogText) }} />
                </DialogContent>
                <DialogActions>
                    <CustomLoadingButton
                        currentTheme={currentTheme}
                        iconPosition="end"
                        endIcon={<MdClose />}
                        onClick={handleCloseNotifyDialog}>{t('close')}</CustomLoadingButton>
                </DialogActions>
            </Dialog>
            {/* Confirm Dialog */}
            <ConfirmDialog
                isOpen={isConfirmDialogOpen}
                onClose={handleCancel}
                onConfirm={handleConfirm}
                dialogTitle={t("confirmation")}
                dialogContent={<p>{objectToAction.action_text}</p>}
            />
            {isProcessing && (
                <motion.div
                    className="processing-dialog"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1, transition: { duration: 1 } }}
                    exit={{ opacity: 0, transition: { duration: 1 } }}
                >
                    <div className="processing-wrapper">
                        <GridLoader
                            color="#F44336"
                            style={{
                                height: "50px",
                                width: "50px",
                            }}
                        />
                    </div>
                </motion.div>
            )}
            {/* email component */}
            {emailDialogOpen && (
                <motion.div
                    className="overlay-dialog"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1, transition: { duration: 1 } }}
                    exit={{ opacity: 0, transition: { duration: 1 } }}
                >
                    <div className="overlay-wrapper">
                        <div className="overlay-navbar">
                            <span className="main-title">{t('email').toUpperCase()}</span>
                            <CircularButton currentTheme={currentTheme} onClick={() => setEmailDialogOpen(false)} icon={<MdClose />} width={"35px"} height={"35px"} />
                        </div>
                        <div className="overlay-content">
                            <EmailComponent setEmailDialogOpen={setEmailDialogOpen} emailData={emailData} />
                        </div>
                    </div>
                </motion.div>
            )}

            {settleTradeDialogOpen && (
                <motion.div
                    className="overlay-dialog"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1, transition: { duration: 1 } }}
                    exit={{ opacity: 0, transition: { duration: 1 } }}
                >
                    <div className="overlay-wrapper">
                        <div className="overlay-navbar">
                            <span className="main-title">{t('settleTrade').toUpperCase()}</span>
                            <CircularButton
                                currentTheme={currentTheme}
                                onClick={() => {
                                    try {
                                        handleSetTradeData("execution_price", 0);
                                        handleSetTradeData("executed_quantity", 0);
                                        handleSetTradeData("execution_fc_amount", 0);
                                        handleSetTradeData("execution_lc_amount", 0);
                                        setSettleTradeDialogOpen(false);
                                    } catch (error) {
                                        console.log(error);
                                    }
                                }} icon={<MdClose />} width={"35px"} height={"35px"} />
                        </div>
                        <div className="overlay-content" style={{ alignItems: "flex-end" }}>
                            {["Equity"].includes(tradeData?.security_type) &&
                                <div className="settle-equity-wrapper">
                                    <div className="input-item-with-label">
                                        <label
                                            htmlFor="exec_fc_amount"
                                            className="form-dropdown-label"
                                            style={{ width: "100px" }}
                                        >
                                            {t('value').toUpperCase()}
                                        </label>
                                        <input
                                            id="exec_fc_amount"
                                            name="exec_fc_amount"
                                            type="text"
                                            placeholder="0.00"
                                            className="form-input-item"
                                            style={{ width: "200px", textAlign: "end" }}
                                            value={tradeData?.execution_fc_amount}
                                            onChange={(e) => handleSetTradeData("execution_fc_amount", e.target.value)}
                                            onBlur={(e) => {
                                                try {
                                                    if (e.target.value) {
                                                        const strippedValue = parseFloat(formatStringToNumberV2(e.target.value));

                                                        console.log(`strippedValue ... ${strippedValue}`);
                                                        if (isNaN(strippedValue)) {
                                                            setNotifyDialogTitle("Error!");
                                                            setNotifyDialogText(`Invalid Number <strong>${strippedValue}</strong>`);
                                                            setIsNotifyDialogOpen(true);
                                                            return;
                                                        }
                                                        handleSetTradeData("execution_fc_amount", formatAmountsToDecimals(strippedValue || 0, 2));
                                                        const rate = parseFloat(tradeData?.hd_cur_rate || 1);
                                                        const lcAmount = parseFloat((strippedValue * rate).toFixed(4));
                                                        handleSetTradeData("execution_lc_amount", formatAmountsToDecimals(lcAmount || 0, 2));
                                                    }
                                                } catch (error) {
                                                    console.log(error)
                                                }
                                            }}
                                        />
                                    </div>
                                    <div className="input-item-with-label">
                                        <label
                                            htmlFor="exec_price"
                                            className="form-dropdown-label"
                                            style={{ width: "100px" }}
                                        >
                                            {t('price').toUpperCase()}
                                        </label>
                                        <input
                                            id="exec_price"
                                            name="exec_price"
                                            type="text"
                                            placeholder="0.00"
                                            className="form-input-item"
                                            style={{ width: "200px", textAlign: "end" }}
                                            value={tradeData?.execution_price}
                                            onChange={(e) => handleSetTradeData("execution_price", e.target.value)}
                                            onBlur={(e) => {
                                                try {
                                                    if (e.target.value) {
                                                        const strippedValue = parseFloat(formatStringToNumberV2(e.target.value));
                                                        if (isNaN(strippedValue)) {
                                                            setNotifyDialogTitle("Error!");
                                                            setNotifyDialogText(`Invalid Number <strong>${strippedValue}</strong>`);
                                                            setIsNotifyDialogOpen(true);
                                                            return;
                                                        }
                                                        handleSetTradeData("execution_price", formatAmountsToDecimals(strippedValue || 0, 2));
                                                        const investedFc = parseFloat(formatStringToNumberV2(tradeData?.execution_fc_amount) || 1);
                                                        const price = strippedValue;
                                                        const allocatedUnits = investedFc / price;
                                                        handleSetTradeData("executed_quantity", formatAmountsToDecimals(allocatedUnits, 2));
                                                    }
                                                } catch (error) {
                                                    console.log(error)
                                                }
                                            }}
                                        />
                                    </div>
                                    <div className="input-item-with-label">
                                        <label
                                            htmlFor="units_bought_eqt"
                                            className="form-dropdown-label"
                                            style={{ width: "100px" }}
                                        >
                                            {t('units').toUpperCase()}
                                        </label>
                                        <input
                                            id="units_bought_eqt"
                                            name="units_bought_eqt"
                                            type="text"
                                            placeholder="0.00"
                                            className="form-input-item"
                                            style={{ width: "170px", textAlign: "end" }}
                                            value={tradeData?.executed_quantity}
                                            onChange={(e) => handleSetTradeData("executed_quantity", e.target.value)}
                                            disabled={true}
                                        />
                                    </div>
                                </div>}
                            {["Bond", "T-Bill"].includes(tradeData?.security_type) &&
                                <div className="settle-bond-wrapper">
                                    <div className="input-item-with-label">
                                        <label
                                            htmlFor="bond_fc_amount"
                                            className="form-dropdown-label"
                                            style={{ width: "100px" }}
                                        >
                                            {t('value').toUpperCase()}
                                        </label>
                                        <input
                                            id="bond_fc_amount"
                                            name="bond_fc_amount"
                                            type="text"
                                            placeholder="0.00"
                                            className="form-input-item"
                                            style={{ width: "200px", textAlign: "end" }}
                                            value={tradeData?.hd_fc_amount}
                                            onChange={(e) => handleSetTradeData("hd_fc_amount", e.target.value)}
                                            onBlur={async (e) => {
                                                try {
                                                    if (e.target.value) {
                                                        const strippedValue = parseFloat(formatStringToNumberV2(e.target.value));
                                                        if (isNaN(strippedValue)) {
                                                            setNotifyDialogTitle("Error!");
                                                            setNotifyDialogText(`Invalid Number <strong>${strippedValue}</strong>`);
                                                            setIsNotifyDialogOpen(true);
                                                            return;
                                                        }
                                                        handleSetTradeData("hd_fc_amount", formatAmountsToDecimals(strippedValue || 0, 2));
                                                        const rate = parseFloat(tradeData?.hd_cur_rate || 1);
                                                        const lcAmount = parseFloat((strippedValue * rate).toFixed(4));
                                                        handleSetTradeData("hd_lc_amount", formatAmountsToDecimals(lcAmount || 0, 2));

                                                        const faceValueLc = parseFloat((parseFloat(formatStringToNumberV2(tradeData?.face_value_fc || 0, 2)) * rate).toFixed(4));
                                                        const cleanPriceLc = parseFloat((parseFloat(formatStringToNumberV2(tradeData?.clean_price_fc || 0, 2)) * rate).toFixed(4));

                                                        const res = await newRequest.post("/trade/bondUnits", {
                                                            trade_docid: tradeDocId,
                                                            hd_fc_amount: strippedValue,
                                                            hd_lc_amount: lcAmount,
                                                            clean_price_fc: parseFloat(formatStringToNumberV2(tradeData?.clean_price_fc || 0, 2)) || 0,
                                                            clean_price_lc: cleanPriceLc || 0,
                                                            face_value_fc: parseFloat(formatStringToNumberV2(tradeData?.face_value_fc || 0, 2)) || 0,
                                                            face_value_lc: faceValueLc || 0
                                                        });

                                                        // console.log(`bondUnits  ${JSON.stringify(res.data, null, 2)}`);
                                                        handleSetTradeData("hd_fc_amount", formatAmountsToDecimals(res.data?.doc?.net_fc_amount || 0, 2));
                                                        handleSetTradeData("hd_lc_amount", formatAmountsToDecimals(res.data?.doc?.net_lc_amount || 0, 2));
                                                        handleSetTradeData("execution_price", formatAmountsToDecimals(tradeData?.face_value_fc || 0, 2));
                                                        handleSetTradeData("executed_quantity", formatAmountsToDecimals(res.data?.doc?.unitsBought || 0, 2));
                                                        handleSetTradeData("execution_fc_amount", formatAmountsToDecimals(res.data?.doc?.net_fc_amount || 0, 2));
                                                        handleSetTradeData("execution_lc_amount", formatAmountsToDecimals(res.data?.doc?.net_lc_amount || 0, 2));
                                                    }
                                                } catch (error) {
                                                    console.log(error)
                                                }
                                            }}
                                        />
                                    </div>
                                    <div className="input-item-with-label">
                                        <label
                                            htmlFor="bonds_coupon"
                                            className="form-dropdown-label"
                                            style={{ width: "100px" }}
                                        >
                                            {t('coupon').toUpperCase()}
                                        </label>
                                        <input
                                            id="bonds_coupon"
                                            name="bonds_coupon"
                                            type="text"
                                            placeholder="0.00"
                                            className="form-input-item"
                                            style={{ width: "170px", textAlign: "end" }}
                                            value={tradeData?.coupon_rate}
                                            onChange={(e) => handleSetTradeData("coupon_rate", e.target.value)}
                                            disabled={true}
                                        />
                                    </div>
                                    <div className="input-item-with-label">
                                        <label
                                            htmlFor="bonds_coupon_qty"
                                            className="form-dropdown-label"
                                            style={{ width: "100px" }}
                                        >
                                            {t('units').toUpperCase()}
                                        </label>
                                        <input
                                            id="bonds_coupon_qty"
                                            name="bonds_coupon_qty"
                                            type="text"
                                            placeholder="0.00"
                                            className="form-input-item"
                                            style={{ width: "170px", textAlign: "end" }}
                                            value={tradeData?.executed_quantity}
                                            onChange={(e) => handleSetTradeData("executed_quantity", e.target.value)}
                                            disabled={true}
                                        />
                                    </div>
                                </div>}
                            {["Deposit"].includes(tradeData?.security_type) &&
                                <div className="settle-fdeposit-wrapper">
                                </div>}
                            <div className="input-item-with-label">
                                <label
                                    htmlFor="settle_date"
                                    className="form-dropdown-label"
                                    style={{ width: "max-content" }}
                                >
                                    {t('On').toUpperCase()}
                                </label>
                                <input
                                    id="settle_date"
                                    name="settle_date"
                                    type="date"
                                    placeholder={t('settlement').toUpperCase()}
                                    className="form-input-item"
                                    style={{ width: "200px" }}
                                    value={tradeData?.settlement_date}
                                    onChange={(e) => {
                                        try {
                                            const formattedDate = moment(e.target.value).format("YYYY-MM-DD");
                                            handleSetTradeData("settlement_date", formattedDate);
                                        } catch (error) {
                                            console.log(error);
                                        }
                                    }}
                                />
                            </div>
                        </div>
                        <div className="overlay-actions">
                            <CustomLoadingButton
                                borderRadiusType="none"
                                currentTheme={currentTheme}
                                endIcon={<MdOutlineReceiptLong />}
                                iconPosition="end"
                                onClick={async () => {
                                    try {
                                        if (!tradeData?.execution_fc_amount) {
                                            setNotifyDialogTitle(t('error'));
                                            setNotifyDialogText("Please enter settlement value");
                                            setIsNotifyDialogOpen(true);
                                            return;
                                        }

                                        if (!tradeData?.execution_price) {
                                            setNotifyDialogTitle(t('error'));
                                            setNotifyDialogText("Please enter settlement price");
                                            setIsNotifyDialogOpen(true);
                                            return;
                                        }
                                        // Revalidate invested amount
                                        const instructionFc = parseFloat(formatStringToNumberV2(tradeData?.hd_fc_amount) || 1);
                                        const investedFc = parseFloat(formatStringToNumberV2(tradeData?.execution_fc_amount) || 1);

                                        if (investedFc > instructionFc) {
                                            setNotifyDialogTitle(t('error'));
                                            setNotifyDialogText(`You cannot execute a trade above ${tradeData?.hd_cur_code} : ${numeral(instructionFc).format("0,0.00")}`);
                                            setIsNotifyDialogOpen(true);
                                            return;
                                        }

                                        if (!tradeData?.settlement_date) {
                                            setNotifyDialogTitle(t('error'));
                                            setNotifyDialogText("Please enter settlement date");
                                            setIsNotifyDialogOpen(true);
                                            return;
                                        }

                                        const glDate = moment(tradeData?.hd_gl_date);
                                        const settleDate = moment(tradeData?.settlement_date);

                                        if (glDate.isAfter(settleDate)) {
                                            setNotifyDialogTitle(t('error'));
                                            setNotifyDialogText(
                                                `Settlement date <b>${settleDate.format("DD-MMM-YYYY")}</b> cannot be greater than instructions date <b>${glDate.format("DD-MMM-YYYY")}</b>.<br><br>Please rectify!`
                                            );
                                            setIsNotifyDialogOpen(true);
                                            return;
                                        }
                                        await newRequest.post("/trade/upd", {
                                            trade_docid: tradeDocId,
                                            hd_status: "Settled",
                                            settlement_status: "Settled",
                                            execution_fc_amount: parseFloat(formatStringToNumberV2(tradeData?.execution_fc_amount, 6)),
                                            execution_lc_amount: parseFloat(formatStringToNumberV2(tradeData?.execution_lc_amount, 6)),
                                            execution_price: parseFloat(formatStringToNumberV2(tradeData?.execution_price, 6)),
                                            executed_quantity: parseFloat(formatStringToNumberV2(tradeData?.executed_quantity, 6)),
                                            settlement_date: tradeData?.settlement_date,
                                        });

                                        try {
                                            await newRequest.post(
                                                "/trace/add",
                                                {
                                                    trc_action_on: "Document",
                                                    trc_doc_docid: tradeData?._id,
                                                    trc_doc_no: tradeData?.hd_no,
                                                    trc_doc_type: "AM Trade",
                                                    trc_aent_code: "",
                                                    trc_ent_code: tradeData?.broker_code,
                                                    trc_action: "trade settled",
                                                    trc_remarks: "settled this trade",
                                                    trc_tags: ["settled this trade"],
                                                },
                                            );
                                        } catch (error) {
                                            console.log(error);
                                        }
                                        setSettleTradeDialogOpen(false);
                                        showToast(t('tradeSettled', { param1: tradeData?.hd_no }), "success");
                                        await fetchTrade(tradeDocId);
                                    } catch (error) {
                                        console.log(error);
                                    }
                                }}
                            >{t('settle').toUpperCase()}</CustomLoadingButton>
                        </div>
                    </div>
                </motion.div>
            )}
            {reportsDialogOpen && (
                <motion.div
                    className="overlay-dialog reports"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1, transition: { duration: 1 } }}
                    exit={{ opacity: 0, transition: { duration: 1 } }}
                >
                    <div className="overlay-wrapper">
                        <div className="overlay-navbar">
                            <h1 className="main-title">{t('reports')}</h1>
                            <CircularButton currentTheme={currentTheme} onClick={() => setReportsDialogOpen(false)} icon={<MdClose />} width={"35px"} height={"35px"} />
                        </div>
                        <div className="overlay-content">
                            <OnScreenReports
                                reportGroupArray={tradeData?.report_keys_array}
                                documentData={{
                                    docNo: tradeData?.hd_no,
                                    docType: "AM Trade",
                                    docId: tradeDocId,
                                    sub_docid: tradeDocId,

                                }} />
                        </div>
                    </div>
                </motion.div>
            )}
            {isConfettiActive && <Confetti />}
        </motion.div>
    );
};


export default AmTrade;
